import { Component, OnInit,EventEmitter,Output, TemplateRef, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { FormsService } from '../../applicationModules/eSignature/services/forms.service';
import { SignaturePad } from 'angular2-signaturepad';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { I18nInterface} from 'ngx-image-drawing'
import { ResizedEvent } from 'angular-resize-event';
import { HttpClient,HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
const  { detect } = require('detect-browser');
const browser = detect();
import {MatAccordion} from '@angular/material/expansion';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DateAdapter,MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { I } from '@angular/cdk/keycodes';


const moment =  _moment;
@Component({
  selector: 'app-tabularsignature',
  templateUrl: './tabularsignature.component.html',
  styleUrls: ['./tabularsignature.component.scss'],
  providers: [
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ],
})

export class TabularSignatureComponent implements OnInit {

  @ViewChild(MatAccordion) accordion: MatAccordion;

  geolocationPosition: any;
  signOpt: string = 'draw';
  signName: string;
  flash:boolean = false;
  showFiles:boolean = false;
  token:any="";
  participantJson:any=[];
  locale:string ="en"; 
  particiantJsonList:any=[];
  projectDocumentsDetailsList:any=[];
  pjtDocumentImgThumbs:any=[];
  signOrInitialImageObj: any[];
  signInitialFontFamily: any;
  signatureBase64: string;
  rows: any = [];
  column: any = [];
  tblrows:any;
  tblcoloumn:any;
  buttonText:string='Button';
  highLightColor:any;
  xposition:any;
  yposition:any;
  selectedDocumentId: any;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;
  autoFill:boolean = false;
  public i18n: I18nInterface={
    saveBtn:"Save as image as JPEG",
    sizes:{extra:"Extra"}
  }
  @Output() dateChange:EventEmitter< MatDatepickerInputEvent< any>>;

 @ViewChild('fillForm',{static:true}) fillFormTemplate:TemplateRef<any>;
  
  
  tblrowsnumber:any;
  tblclmnumber:any;
  tblid:any;
  tbldata:any;
  Imageurl:any;
  selected:any;
  isAcceptButtonDisabled:boolean=false;

  readonly:any;
  isRequired:any;
  ControlId:any;
  ControlData:any;
  formData: FormData = new FormData();
  signaturePadOptions: any = { 
    'minWidth': 5,
    'canvasWidth': 500,
    'canvasHeight': 300,
    'penColor':""
  };
  brushColor:string=""
 
  bulletFieldArray: Array<any> = [];
  bulletFieldAttribute: any = {
    val: '',
  };
  radioButtonGroupFieldArray:Array<any>=[];
  radioButtonGroupFieldAttribute: any = {
    val: '',
  };
  databaseId:any;
  organizationId:any;

  fontSize=[
    { fontsize:7 },
    { fontsize:8 },
    { fontsize:9 },
    { fontsize:10 },
    { fontsize:11 },
    { fontsize:12 },
    { fontsize:14 },
    { fontsize:16 },
    { fontsize:18 },
    { fontsize:20 },
    { fontsize:22 },
    { fontsize:24 },
    { fontsize:26 },
    { fontsize:28 },
    { fontsize:36 },
    { fontsize:48 },
    { fontsize:72 }
  ]

  family = [
    {font: 'Architects Daughter, cursive'},
    {font: 'Dancing Script, cursive'},
    {font: 'Pacifico, cursive'},
    {font: 'Satisfy, cursive'},
    {font: 'Caveat, cursive'},
    {font: 'Cookie, cursive'},
    {font: 'Great Vibes, cursive'},
    {font: 'Parisienne, cursive'},
    {font: 'Sacramento, cursive'},
    {font: 'Yellowtail, cursive'},
    {font: 'Alex Brush, cursive'},
    {font: 'Allura, cursive'},
    {font: 'Damion, cursive'},
    {font: 'Homemade Apple, cursive'},
    {font: 'Leckerli One, cursive'},
    {font: 'Mr Dafoe, cursive'},
    {font: 'Nothing You Could Do, cursive'},
    {font: 'Pinyon Script, cursive'},
    {font: 'Tangerine, cursive'},
    {font: 'Cedarville Cursive, cursive'},
    {font: 'Grand Hotel, cursive'},
    {font: 'Herr Von Muellerhoff, cursive'},
    {font: 'Italianno, cursive'},
    {font: 'Kristi, cursive'},
    {font: 'Niconne, cursive'},
    {font: 'Norican, cursive'},
    {font: 'Petit Formal Script, cursive'},
    {font: 'Rochester, cursive'},
    {font: 'Bilbo Swash Caps, cursive'},
    {font: 'Clicker Script, cursive'},
    {font: 'Dawning of a New Day, cursive'},
    {font: 'Euphoria Script, cursive'},
    {font: 'Ma Shan Zheng, cursive'},
    {font: 'Mr De Haviland, cursive'},
    {font: 'Qwigley, cursive'},
    {font: 'Sofia Script, cursive'},
    {font: 'The Girl Next Door, cursive'},
    {font: 'Zeyada, cursive'},
    {font: 'Beth Ellen, cursive'},
    {font: 'Charmonman, cursive'},
    {font: 'Devonshire, cursive'},
    {font: 'Dr Sugiyama, cursive'},
    {font: 'Engagement, cursive'},
    {font: 'League Script, cursive'},
    {font: 'Meie Script, cursive'},
    {font: 'Mr Bedfort, cursive'},
    {font: 'Romanesco, cursive'},
    {font: 'Stalemate, cursive'},
    {font: 'Zhi Mang Xing, cursive'},
  ]  

  fontfamilys = [
    {font: 'Arail'},
    {font: 'Calibri'},
    {font: 'Roboto'},
    {font: 'Tahoma'},
    {font: 'Verdana'},
  ] ;
  link = [
    'https://fonts.googleapis.com/css2?family=Architects+Daughter&family=Caveat&family=Cookie&family=Dancing+Script&family=Great+Vibes&family=Pacifico&family=Parisienne&family=Sacramento&family=Satisfy&family=Yellowtail&display=swap',
    'https://fonts.googleapis.com/css2?family=Alex+Brush&family=Allura&family=Damion&family=Homemade+Apple&family=Leckerli+One&family=Mr+Dafoe&family=Nothing+You+Could+Do&family=Pinyon+Script&family=Tangerine&display=swap',
    'https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Grand+Hotel&family=Herr+Von+Muellerhoff&family=Italianno&family=Kristi&family=Mrs+Saint+Delafield&family=Niconne&family=Norican&family=Petit+Formal+Script&family=Rochester&display=swap',
    'https://fonts.googleapis.com/css2?family=Bilbo+Swash+Caps&family=Clicker+Script&family=Dawning+of+a+New+Day&family=Euphoria+Script&family=Ma+Shan+Zheng&family=Mr+De+Haviland&family=Qwigley&family=Sofia&family=The+Girl+Next+Door&family=Zeyada&display=swap',
    'https://fonts.googleapis.com/css2?family=Beth+Ellen&family=Charmonman&family=Devonshire&family=Dr+Sugiyama&family=Engagement&family=League+Script&family=Meie+Script&family=Mr+Bedfort&family=Romanesco&family=Stalemate&family=Zhi+Mang+Xing&display=swap'
  ];
  dropdownFieldArray:  Array<any> = [];
  dropdownFieldAttribute: any = {
    val: '',
  };

  checkboxFieldArray:  Array<any> = [];
  checkboxFieldAttribute: any = {
    val: '',
  };

  checkboxGroupFieldArray:  Array<any> = [];
  checkboxGroupFieldAttribute: any = {
    val: '',
  };
  
  characterlimit:any;
  textColor:any;
  fontsize:any;
  fontstyle:any;
  fontweight:any;
  textdecoration:any;
  fontfamily:any;
  textalign:any;



  showToolsLeft: boolean = false;
  ShowtoolDetail: boolean = false;
  Sdropdown: boolean = false;
  SURLL: boolean = false;
  Smuldropdown: boolean = false;
  Sbutton: boolean = false;
  Stext: boolean = false;
  SButtontext: boolean = false;
  SURL: boolean = false;
  Ssingleline: boolean = false;
  Sformat: boolean = true;
  Snumber: boolean = false;
  Sradio: boolean = false;
  Scheckbox: boolean = false;
  Scheckboxgroup: boolean = false;
  Stable: boolean = false;
  Sbullet: boolean = false;
  Sdraw: boolean = false;
  Sline: boolean = false;
  ShighLight:boolean=false;
  Sthrough:boolean=false;
  Smeasure: boolean = false;
  rotationByDegree:number=0;
  Smultiline: boolean = false;
  Sapproval: boolean = false;
  SwhiteOut:boolean = false;
  Ssign:boolean=false;
  SreadOnly:boolean=false;

  Ssignature: boolean = false;
  Sinitials: boolean = false;
  Sdate: boolean = false;
  Stime: boolean = false;
  Slocation: boolean = false;

  SbuttonLabel: boolean = false
  Sfile:boolean=false;
  Simage:boolean=false;


  buttonURL:string="";
  acceptOrdeclineText:string="";
  acceptchecked:boolean=false;
  declinechecked:boolean=false;
  dropdownddisabled:boolean=false;

  showHeader:boolean=false;
  showSidebar:boolean=false;

  movingOffset = { x: 0, y: 0 };
  endOffset = { x: 0, y: 0 };

  text:string="";
  groupRelationParticipantId:number=0;
  projectDocumentImagesList:any=[];
  IsSigningComplete:boolean=false;
  participantArray: any=[];
  
  @ViewChild('content') content: ElementRef;

  responseArray: any=[]; 
  singlLineWithFields: any = [];
  allPdfHTML:any=[];
  allPdfHTML1:any=[];   
  isPageLoaded:boolean=false;
  spinner:boolean=false;
  indexExpanded: number=0;
  imageHeight: any;
  imageWidth: any;

  innerhtmlvalue :string ="";
  drawingImgeHeight:string ="";
  isDrawing:boolean = false;
  previousdrawings:any=[];
  indicesDrawn:Array<any>=[];
  canvasIndex:number =0;
  autofillvalues:any;
  reasonToDecline:string="";
  declineButtonShow:boolean=false;
  controlAlignArray:any=[]
  beforeFillForm:any;
  isControlEnabled:boolean = false;
  controlIndex:number =0;
  showAllRequiredControls:boolean=false;
  signatureImage:any;

  ipAddress:any;
  browsername:any;
  device:any;
  eventLogMessage:any;
  responseHolder: any;
  projectID:number=0;
  userID: any;
  participantEmailId:any;

  // For Audit Page
  auditPage:boolean=false;
  Subject:string="";
  DocumentName:string="";
  flowtricsId:string="";
  Status:string="";
  Participants:number=0;
  Document:number=0;
  Pages:number=0;
  DocumentHistory:any=[];
  isLastParticipant:boolean=false;
  projectName:string="";
  particiantJsonListAutoFill: any=[];
  particiantJsonListAutoFillCore: any=[];
  particiantJsonListAutoFillCom: any=[];
  fieldFolders: any;
  particiantJsonListAutoFillBeforFill: any;
  particiantJsonListAutoFillCoreBeforFill: any;
  particiantJsonListAutoFillComBeforFill: any;
  openPanel: number=0;
  UnChnagedparticipantJsonList: any;
  UnChnagedparticipantJsonListArray: any=[];
  docstoFill: any[];
  nonSelectedDocJsonList: any=[];
  coreModule:string="";
  contactModule:string="";
  companyModule:string="";
  constructor(private http: HttpClient,private httpbackend:HttpBackend,private dialog: MatDialog,private router:Router,
    private route: ActivatedRoute, private formsService:FormsService,
    private loaderService: LoaderService,private toastr: ToastrService,
    private cdr: ChangeDetectorRef, private statusConstant: StatusConstant) {     
      var skipper = new HttpClient(httpbackend);
      skipper.get<{ip:string}>('https://jsonip.com').subscribe( data => {       
        this.ipAddress = data.ip;
      });
      this.addfont();
     }  

     addfont(){
      for (var i = 0; i < this.link.length; i++) {      
        const cssURL = this.link[i];       
        let node = document.createElement('link');
        node.href = cssURL;
        node.rel = 'stylesheet';
        const s = document.getElementsByTagName('link')[0]
        s.parentNode.insertBefore(node, s);
      }
    }
       
   ngOnInit(): void {    
    if (browser) {
      this.browsername=browser.name;
      this.device=browser.os;     
    }

    this.isPageLoaded=false;    
    this.highLightColor=this.hexToRGBA("#FFFF00",0.2);
    this.text="";
    this.getQueryParameter();
    this.getParticipantJson();
    this.getStateDropdownList(231);
  }   

  getQueryParameter(){
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
   });
  }
  
   // To Add Project EventLog  //
   async AddProjectEventLog(status,eventLogMessage) {
    try {
      var ReqModel={
        projectID: this.projectID,
        ipAddress: this.ipAddress,
        message: eventLogMessage,
        eventType: status,  //Send=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        device: this.device,
        browser: this.browsername,
        userID:this.userID,
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId),
      }
      const result = await this.formsService.AddProjectEventLog(ReqModel).toPromise();
      this.responseHolder = result;     
      if (this.responseHolder.status === this.statusConstant.statusSuccess) {
        if(status==4){
          this.GetProjectAuditLog();
         }
      } else {
      }
    } catch (e) {
      Observable.throw(e);
    }
  }
  
  isReadOnlyGroupParticipant:boolean;
  getParticipantJson(){
    this.responseArray=[];
    let reqModel ={
      token:encodeURIComponent(decodeURIComponent(this.token)),
      IsNormalForm:false
    }
    this.dialog.closeAll();
    this.loaderService.show();
    this.spinner=true;
    this.formsService.getTabularJson(reqModel).subscribe(response=>{
      let responseData = response.data;    
      this.responseArray = response.data;
      this.fieldFolders = response.data.fieldFolders
      if(this.fieldFolders.length>0 && this.fieldFolders.find(m=>m.name=='Core'))
      {
       this.coreModule=this.fieldFolders.find(m=>m.name=='Core').orgModuleName;
      }
      if(this.fieldFolders.length>0 && this.fieldFolders.find(m=>m.name=='Contact'))
      {
       this.contactModule=this.fieldFolders.find(m=>m.name=='Contact').orgModuleName;
      }
      if(this.fieldFolders.length>0 && this.fieldFolders.find(m=>m.name=='Company'))
      {
       this.companyModule=this.fieldFolders.find(m=>m.name=='Company').orgModuleName;
      }
      this.projectID = response.data.projectID;
      this.userID = response.data.userID;
      this.databaseId = response.data.databaseID;
      this.organizationId = response.data.organizationID;
      this.participantEmailId = "";//response.data.participantInfoForUI.email;
      //this.isLastParticipant = response.data.isLastParticipant;
      //Send=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
      //this.AddProjectEventLog(2,"Viewed by "+'('+ this.participantEmailId+')');

      this.groupRelationParticipantId =0;// responseData.groupRelationParticipantMappingID;

      // Step 1 for checking disabled fields
      if(responseData.participantJsonList){
        responseData.participantJsonList.forEach(j => {
          if(!this.UnChnagedparticipantJsonListArray.find(b=>b.documentID==j.documentID) && j.documentID>0)// remove duplicate Json
            this.UnChnagedparticipantJsonListArray.push({participantJson:j.participantJson,
            documentID:j.documentID,
            name: responseData.projectDocumentDetail.find(n=>n.projectDocumentID==j.documentID).documentName});
        });
      }
      // Step 2 for checking disabled fields
      // ** Step 1 seems duplicate but it is not, as needed to find disabled fields.

      responseData.participantJsonList.forEach(elmt => {
        this.selectedDocumentId=elmt.documentID;
        let jsonTOCheckDisabledControls=JSON.parse(elmt.participantJson);
        jsonTOCheckDisabledControls.forEach(eln => {
          eln.fields.forEach(fel => {
            fel.isDisabled=!this.checkIfEnabled(fel,eln)
            if(fel.Control=='Static'){
              fel.isDisabled=true;
            }
          });
      });
      elmt.participantJson=JSON.stringify(jsonTOCheckDisabledControls);
      });
     
      if(responseData.participantJsonList){
        this.UnChnagedparticipantJsonListArray=[];
        responseData.participantJsonList.forEach(j => {
          if(!this.participantJson.find(b=>b.documentID==j.documentID) && j.documentID>0)// remove duplicate Json
            this.participantJson.push(j);
          if(!this.UnChnagedparticipantJsonListArray.find(b=>b.documentID==j.documentID) && j.documentID>0)// remove duplicate Json
          this.UnChnagedparticipantJsonListArray.push({participantJson:j.participantJson,
            documentID:j.documentID,
            name:responseData.projectDocumentDetail.find(n=>n.projectDocumentID==j.documentID).documentName});
         
          if(!this.participantArray.find(b=>b.documentID==j.documentID) && j.documentID>0) // remove duplicate Json
            this.participantArray.push({
              groupRelationParticipantMappingID:this.groupRelationParticipantId,
              participantJson:j.participantJson,
              documentID:j.documentID,
              projectParticipantJsonID:j.projectParticipantJsonID
            });
        });
      }
      
        
       
      //this.participantJson = responseData.participantJsonList;      
      this.isReadOnlyGroupParticipant =false;// responseData.isFromReadOnlyGroup;
      if(responseData.hasCompleted==null)
      this.IsSigningComplete = false
      else
      this.IsSigningComplete=true;
      this.projectDocumentImagesList = responseData.projectDocumentPageImageList;
    
      this.projectDocumentsDetailsList = responseData.projectDocumentDetail;
      this.pjtDocumentImgThumbs=[];    
    
      
      this.projectDocumentsDetailsList.forEach(prjDocDetail=>{
        let prjThumsList=[];
        let images=this.projectDocumentImagesList.filter(m=>m.documentID==prjDocDetail.projectDocumentID); 
          images=images.sort(function(a, b){return a.pageNumber-b.pageNumber});
          if(images.length>0)
          {
            prjThumsList=images;
          }
        this.pjtDocumentImgThumbs.push({
          prjDocDetail: prjDocDetail,
          pjtDocumentImgThumbs:prjThumsList
        });
       
        if( this.indexExpanded==undefined){
          this.indexExpanded =0;
        }
        this.indexExpanded =  this.indexExpanded;  
      });
      this.projectDocumentsDetailsList.forEach(element => {
        let doc= this.participantJson.find(e=>e.documentID == element.projectDocumentID);
        if(doc==undefined){

          let participantJsonList = []
          let images=this.projectDocumentImagesList.filter(m=>m.documentID==element.projectDocumentID); 
          images.forEach(e => {
            participantJsonList.push({img: e.pageImageUrl,fields: [],projectParticipantJsonID:0})
          });
          this.participantJson.push({
            groupRelationParticipantMappingID:this.groupRelationParticipantId,
            participantJson:JSON.stringify(participantJsonList),
            documentID:element.projectDocumentID,
            projectParticipantJsonID:0,
            hasCompleted:null,
            imageHeight:element.imageHeight,
            imageWidth:element.imageWidth
          })
        }
      });
   
     this.FillDocImagesWithFields();  
       setTimeout(() => {
        if(!this.IsSigningComplete)
        this.fillForms(this.fillFormTemplate);
       },1000);
    
     this.isPageLoaded=true;
     this.loaderService.hide();
     this.spinner=false;
     if(responseData.isExpired)
     this.toastr.warning('The token used here is expired.');
    });
  }

  wait(ms) {
      var d:any = new Date();
      var d2 = null;
      do { d2 = new Date(); }
      while(d2-d < ms);
  }

  // Get Project Audit Log  //
  GetProjectAuditLog() {
    var ReqModel={
      projectID: this.projectID,
      userID: this.userID,
      organizationID:this.organizationId,
      databaseID: Number(this.databaseId),
    }
    this.formsService.GetProjectAuditLog(ReqModel).subscribe((response) => {
       if (response != undefined) {
        this.isLastParticipant=true;
        this.responseHolder = response;
        if(this.responseHolder.status == this.statusConstant.statusSuccess) {      
         
           this.Subject=this.responseHolder.data.subject;
           this.DocumentName=this.responseHolder.data.documentNames;
           this.flowtricsId=this.responseHolder.data.projectGuiD;
           this.Status=this.responseHolder.data.status;
           this.Participants=this.responseHolder.data.participantCount;
           this.Document=this.responseHolder.data.documentCount;
           this.Pages=this.responseHolder.data.pageCount;
           this.projectName = this.responseHolder.data.projectName;
           this.DocumentHistory =this.responseHolder.data.auditLogs.filter((itm) => itm.eventType != "Completed");;
           var Completed = this.responseHolder.data.auditLogs.filter((itm) => itm.eventType === "Completed");
           if(Completed!=null){
            var ReqModels={
              "auditID": Completed[0].auditID,
              "browser": Completed[0].browser,
              "createOn": Completed[0].createOn,
              "device": Completed[0].device,
              "eventType": Completed[0].eventType,
              "ipAddress": Completed[0].ipAddress,
              "message": Completed[0].message,
              "projectID": Completed[0].projectID,
              "userName": Completed[0].userName,
             }
             this.DocumentHistory.push(ReqModels);
           }     
            if(!this.IsSigningComplete){
            if(this.CheckIfRequiredFieldsAreFilled()){
              for(var x=0; x< this.particiantJsonList.length;x++){
                this.particiantJsonList[x].fields.map(e => {
                  if(e.Control=='Static'){                   
                    e.isDisabled=true;
                   // e.filledData=true;
                  }  else{
                    e.isDisabled=false;
                    //e.filledData=false;
                  }  
               });
              }

              let findPreviouslyparticipant=this.participantArray.find(m=> m.documentID==this.selectedDocumentId);
                if(findPreviouslyparticipant){
                this.participantJson.find(m=> m.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
                this.participantArray.find(m=> m.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
               }else{                
                let Current=this.participantJson.find(m=> m.documentID==this.selectedDocumentId);
                Current.participantJson=JSON.stringify(this.particiantJsonList);
                this.participantArray.push({
                  groupRelationParticipantMappingID:this.groupRelationParticipantId,
                  participantJson:JSON.stringify(this.particiantJsonList),
                  documentID:this.selectedDocumentId,
                  projectParticipantJsonID:Current.projectParticipantJsonID
                })
              } 
        
               this.pjtDocumentImgThumbs;
               this.projectDocumentsDetailsList;
               var allPdfHTML=[];  
              
               if(this.isLastParticipant == true) {
                 for(var i=0; i< this.projectDocumentsDetailsList.length;i++){
                  
                  let Current=this.participantJson.find(m=> m.documentID==this.projectDocumentsDetailsList[i].projectDocumentID);
                  this.particiantJsonList = JSON.parse(Current.participantJson);                 
	                              
                  this.cdr.detectChanges();
                  var height = document.getElementById("docHolding1") as HTMLImageElement;
                  var newimgHeight =(height.offsetHeight)+'px'.toString();
                  var newimgwidth =(height.offsetWidth)+'px'.toString();     
                  var html='';  
                  //this.wait(i*1000);
                  this.innerhtmlvalue = document.getElementById("docSign").innerHTML;
                  html="<html lang=&quot;en&quot;><head> <link href='https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap' rel='stylesheet'><meta charset=&quot;utf-8&quot;><meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1&quot;><style> @import 'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap'; .next {display:none; } .docHolding {position:relative;} #imageDrawContainer {vertical-align:top;display:block;left:auto!important;} .iframe-drag-handle { background-color: transparent !important;border: none !important } input, textarea, .customUpdate, .Dtime { background-color: transparent !important; border: none !important; resize: none !important } div.customUpdate {border:none !important}.mat-icon-button, ngx-material-timepicker-toggle, input[type='file']{ display: none !important } table{ border: none !important;border-spacing: 0 !important } mat-select{border:none !important} #loc_Icon,#cloud_upload,#draw_brush,#border_color,#initial_gesture{display:none !important} @font-face {font-family: 'Roboto'; src: 'url'+'('+'https://ecmuiprod-staging.azurewebsites.net/src/assets/font/Roboto/Roboto-Regular.ttf'+')' } @font-face {font-family: 'Calibri'; src: 'url'+'('+'https://ecmuiprod-staging.azurewebsites.net/src/assets/font/calibri/calibri-regular.ttf'+')'} .sig-chrome { border-left: 2px solid #005cb9; border-radius: 8px; display: block; height: 80px; padding:0; overflow: visible; position: relative; } .sig-chrome::before { border-top-left-radius: 8px; border-top-width: 2px; top: -2px; } .sig-chrome::after, .sig-chrome::before { border: 0 solid #005cb9; content: ''; display: block; height: 38px; left: -1px; position: absolute; width: 20px; } .sig-chrome::after { border-bottom-left-radius: 8px; border-bottom-width: 2px; bottom: -2px; } .sig-chrome::before { border-top-left-radius: 8px; border-top-width: 2px; top: -2px; } .sig-chrome-title-top { font-weight: 700; top: -8px; font-family:'Arial, Helvetica, sans-serif' } .sig-chrome-title-bottom, .sig-chrome-title-top { font-size: 12px; left: 21px; position: absolute; white-space: nowrap; } .sig-chrome .sig-container { height: 70px; //overflow: hidden; position: absolute; white-space: nowrap; width: 100%; padding:0 10px; display: flex; justify-content: flex-start; align-items: center; } .sig-container img{ width:100%; height:100%; object-fit:contain;} .sig-chrome .sig-container h3{ padding: 0; font-size: 20px; } .sig-chrome .sig { float: left; max-height: 100%; max-width: 100%; position: relative; top: 50%; -webkit-transform: translateY(-50%); -ms-transform: translateY(-50%); transform: translateY(-50%); } .sig-chrome-title-bottom { bottom: -7px; } </style></head><body style=&quot;background: #979797;&quot; > <div style='width:"+newimgwidth+"; margin: auto; height: auto;'>  "+ this.innerhtmlvalue +"</div>  </body> </html>";
                  // if(this.AllDocsHtml.length>0){
                  //   if(this.AllDocsHtml.find(x=>x.docId==this.projectDocumentsDetailsList[i].projectDocumentID)!=undefined){
                  //   this.innerhtmlvalue= this.AllDocsHtml.find(x=>x.docId==this.projectDocumentsDetailsList[i].projectDocumentID).innerHtmlval;
                  //   }
                  //   html="<html lang=&quot;en&quot;><head> <link href='https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap' rel='stylesheet'> <meta charset=&quot;utf-8&quot;><meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1&quot;><style>.next {display:none; } .docHolding {position:relative;} #imageDrawContainer {vertical-align:top;display:block;left:auto!important;} .iframe-drag-handle { background-color: transparent !important;border: none !important } input, textarea, .customUpdate, .Dtime { background-color: transparent !important; border: none !important; resize: none !important }.mat-icon-button, ngx-material-timepicker-toggle, input[type='file']{ display: none !important } table{ border: none !important;border-spacing: 0 !important } mat-select{border:none !important}  </style></head><body style=&quot;background: #979797;&quot; > <div style='width:"+newimgwidth+"; margin: auto; height: auto;'>  "+ this.innerhtmlvalue +"</div>  </body> </html>"
                  // }else{
                  //  html="<html lang=&quot;en&quot;><head> <link href='https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap' rel='stylesheet'> <meta charset=&quot;utf-8&quot;><meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1&quot;><style>.next {display:none; } .docHolding {position:relative;} #imageDrawContainer {vertical-align:top;display:block;left:auto!important;} .iframe-drag-handle { background-color: transparent !important;border: none !important } input, textarea, .customUpdate, .Dtime { background-color: transparent !important; border: none !important; resize: none !important }.mat-icon-button, ngx-material-timepicker-toggle, input[type='file']{ display: none !important } table{ border: none !important;border-spacing: 0 !important } mat-select{border:none !important}  </style></head><body style=&quot;background: #979797;&quot; > <div style='width:"+newimgwidth+"; margin: auto; height: auto;'>  "+ this.innerhtmlvalue +"</div>  </body> </html>"
                  // }
                  var imgHeight = document.getElementById("imgSrc"+0) as HTMLImageElement;
                  var req={
                    documentName:this.projectDocumentsDetailsList[i].documentName,
                    projectDocumentId:this.projectDocumentsDetailsList[i].projectDocumentID,
                    documentHtml:html,
                    pageWidth:(height.offsetWidth).toString(),
                    pageHeight:(imgHeight.offsetHeight).toString()
                  }
                  req.documentHtml = req.documentHtml as any;
                  allPdfHTML.push(req);
                }
              }  
        
               if(this.isLastParticipant == true) {             
                this.cdr.detectChanges();
                var audit = document.getElementById("auditHolder").innerHTML;
                var htmlaudit="<html lang='en'><head><link href='https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap' rel='stylesheet'><link href='https://fonts.googleapis.com/css2?family=Material+Icons+Outlined' rel='stylesheet'><meta charset=&quot;utf-8&quot;><style> @font-face {font-family: 'Roboto';  src: 'url'+'('+'https://ecmuiprod-staging.azurewebsites.net/src/assets/font/Roboto/Roboto-Regular.ttf'+')'} @import '../../../assets/icons/material-icons/outline/style.css'; body{margin:0; padding:0; box-sizing:border-box; width:100%;   } </style><meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1&quot;></head><body style=&quot;background: #979797;&quot; > <div style='width:100%;'  >  "+ audit +"</div>  </body> </html>"
        
                var reqaudit={
                  documentName:"_Audit",
                  projectDocumentId:0,
                  documentHtml:htmlaudit,
                  pageWidth:(height.offsetWidth).toString(),
                  pageHeight:(imgHeight.offsetHeight).toString()
                }
                reqaudit.documentHtml = reqaudit.documentHtml as any;
                allPdfHTML.push(reqaudit);
               }    
               //return;
               this.participantArray.forEach(element => {
               let particiantJsonListLeftFieldCheck=[];
                particiantJsonListLeftFieldCheck.push(JSON.parse(element.participantJson));
               
                particiantJsonListLeftFieldCheck.forEach(e => {
                  e.forEach(ef => {
                  ef.fields.forEach(field => {
                    if(field.fieldTypeName==="MultiSelect"){
                      if(field.selectedValue!=="" && field.selectedValue!=undefined){
                        if (Array.isArray(field.selectedValue)){
                          field.selectedValue=field.selectedValue.join(",");
                         }
                      }
                    }
                  });
                });
              });
              element.participantJson=JSON.stringify(particiantJsonListLeftFieldCheck[0]);
              });
              
              this.participantArray.forEach(ml =>
                {
                  let currentJsonArray: any = [];
                  currentJsonArray = JSON.parse(ml.participantJson);
                  currentJsonArray.forEach(page =>
                  {
                    page.fields.forEach(elem =>
                    {
                      elem.selectedValue = "";
                      elem.chkSelectedValues = [];
                      elem.signatureBase64 = "";
                      elem.signatureText = "";
                      elem.ImageData = [];
                      elem.rbSelectedValues = [];
                      elem.drawBase64 = "";
                    });
                  });
                  ml.participantJson= JSON.stringify(currentJsonArray);
                });
               let reqPayload = {
                token:encodeURIComponent(decodeURIComponent(this.token)),
                groupRelationParticipantMappingID:this.groupRelationParticipantId,
                participantJsonList :this.participantArray,
                documentHtmls:allPdfHTML,
                projectID : this.projectID,
                userID : this.userID,
                databaseId : this.databaseId,
                organizationId : this.organizationId,
                IsFinalSubmit:true
               };            
              //  return;
                this.dialog.closeAll();
                this.loaderService.show();
                this.formsService.UpdateTabularJson(reqPayload).subscribe(response=>{
                  if (response != undefined) {
                    this.responseHolder = response;
                    if(this.responseHolder.status == this.statusConstant.statusSuccess) {                   
                    this.dialog.closeAll();       
                    this.router.navigate(['/request/thanks']);
                    this.loaderService.hide();
                    }else{
                      this.dialog.closeAll();
                      this.spinner=false;
                    }
                  }else{
                    this.dialog.closeAll();
                    this.spinner=false;
                  }
               });
             }else{
              this.dialog.closeAll();
              this.spinner=false;
              this.loaderService.hide();
             }  
            }else{
            this.dialog.closeAll();
            this.toastr.warning('The document has already been signed cannot re-submit it.');
            this.spinner=false;
            this.loaderService.hide();
            } 
           } else {           
          }
        } else {        
        }
      });
    
  }



  AcceptBtnClick(isFinalSubmit:any){
    if(!this.IsSigningComplete){
      if(isFinalSubmit == true){
        //Send=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
        this.loaderService.show();
        this.isAcceptButtonDisabled=true;
        this.AddProjectEventLog(3,"Signed by "+'('+ sessionStorage.getItem("email") +')');
        this.AddProjectEventLog(4,"This Document has been completed");                                 
        return;
     }

     if(this.isLastParticipant == false){
      this.loaderService.show();
      this.isAcceptButtonDisabled=true;
      if(this.CheckIfRequiredFieldsAreFilled()){
        
        for(var x=0; x< this.particiantJsonList.length;x++){
          this.particiantJsonList[x].fields.map(e => {
            if(e.Control=='Static'){
              e.isDisabled=true;
            //  e.filledData=true;            
            }  else{
              e.isDisabled=false;
              //e.filledData=false;
            }           
         });
        }

        let findPreviouslyparticipant=this.participantArray.find(m=> m.documentID==this.selectedDocumentId);
          if(findPreviouslyparticipant){
          this.participantJson.find(m=> m.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
          this.participantArray.find(m=> m.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
        }else{
          let Current=this.participantJson.find(m=> m.documentID==this.selectedDocumentId);
          this.participantArray.push({
            groupRelationParticipantMappingID:this.groupRelationParticipantId,
            participantJson:JSON.stringify(this.particiantJsonList),
            documentID:this.selectedDocumentId,
            projectParticipantJsonID:Current.projectParticipantJsonID
          })
        }    
        this.participantArray.forEach(element => {
          let particiantJsonListLeftFieldCheck=[];
           particiantJsonListLeftFieldCheck.push(JSON.parse(element.participantJson));
          
           particiantJsonListLeftFieldCheck.forEach(e => {
             e.forEach(ef => {
             ef.fields.forEach(field => {
              if(field.fieldTypeName==="MultiSelect"){
                 if(field.selectedValue!=="" && field.selectedValue!=undefined){
                   if (Array.isArray(field.selectedValue)){
                     field.selectedValue=field.selectedValue.join(",");
                    }
                 }
               }
             });
           });
         });
         element.participantJson=JSON.stringify(particiantJsonListLeftFieldCheck[0]);
         });
         let reqPayload = {
          token:encodeURIComponent(decodeURIComponent(this.token)),
          groupRelationParticipantMappingID:this.groupRelationParticipantId,
          participantJsonList :this.participantArray,
          documentHtmls:[],
          projectID : this.projectID,
          userID : this.userID,
          databaseId : this.databaseId,
          organizationId : this.organizationId,
          IsFinalSubmit:false
         };
         // return;
          this.dialog.closeAll();
          this.formsService.UpdateTabularJson(reqPayload).subscribe(response=>{
            if (response != undefined) {
              this.particiantJsonList.forEach(eln => {
                eln.fields.forEach(fel => {
                  fel.isDisabled=!this.checkIfEnabled(fel,eln)
                  if(fel.Control=='Static'){
                    fel.isDisabled=true;
                  }
                });
            });
              this.responseHolder = response;
             if(this.responseHolder.status == this.statusConstant.statusSuccess) {
              // Send=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
              // True means Last Participant
              // False means not Last Participant
              this.toastr.success("Data saved successfully.");
              if(this.isLastParticipant == false){ 
               this.AddProjectEventLog(3,"Signed by "+'('+ sessionStorage.getItem("email")+')');
              }
              this.dialog.closeAll();       
             // this.router.navigate(['/request/thanks']);
              this.loaderService.hide();
              }
            }else{
              this.dialog.closeAll();
            }
         });
      }else{
        this.isAcceptButtonDisabled=false;
        this.loaderService.hide();
        this.dialog.closeAll();
       }  
      }else{
      this.spinner=false;
      this.isAcceptButtonDisabled=false;
      this.loaderService.hide();
      this.dialog.closeAll();
      this.toastr.warning('The document has already been signed cannot re-submit it.');
      }
    }    
   }
  

  expandProjectImages(projectDocId){
    this.pjtDocumentImgThumbs=[];    
    this.projectDocumentImagesList.forEach(docImgThumbs => {
      if(docImgThumbs.documentID == projectDocId)
      this.pjtDocumentImgThumbs.push(docImgThumbs);
    });   
  }

  AllDocsHtml=[];

  FillDocImagesWithFields(docId:number=0,isUpdateJson:boolean=false,i:number=0) {
    this.index=[];
    if(this.isDrawing){
      this.toastr.warning('Save or cancel draw for moving to other documents.')
      return;
    }
    this.indicesDrawn=[];
    this.indexExpanded=i;
    // if(!this.CheckIfRequiredFieldsAreFilled())
    // {
    //   return;
    // }
    if(isUpdateJson) {
      //Prepare Json previously selected participant      
   let findPreviouslyparticipant=this.participantArray.find(m=> m.documentID==this.selectedDocumentId);
     if(findPreviouslyparticipant){
       if(this.AllDocsHtml.find(x=>x.docId==this.selectedDocumentId)==undefined)
       this.AllDocsHtml.push({innerHtmlval:document.getElementById("docSign").innerHTML,docId:this.selectedDocumentId});
       else{
         var ele = this.AllDocsHtml.find(x=>x.docId==this.selectedDocumentId);
         ele.innerHtmlval=document.getElementById("docSign").innerHTML;
       }
       this.participantArray.find(m=> m.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
    }else{
      if(this.AllDocsHtml.find(x=>x.docId==this.selectedDocumentId)==undefined)
      this.AllDocsHtml.push({innerHtmlval:document.getElementById("docSign").innerHTML,docId:this.selectedDocumentId});
      else{
        var ele = this.AllDocsHtml.find(x=>x.docId==this.selectedDocumentId);
        ele.innerHtmlval=document.getElementById("docSign").innerHTML;
      }
      let Current=this.participantJson.find(m=>
        m.documentID==this.selectedDocumentId);
        Current.participantJson =JSON.stringify(this.particiantJsonList);
        this.participantArray.push({
          groupRelationParticipantMappingID:this.groupRelationParticipantId,
          participantJson:JSON.stringify(this.particiantJsonList),
          documentID:this.selectedDocumentId,
          projectParticipantJsonID:Current==undefined?0: Current.projectParticipantJsonID
        })    
      }
    }
     let doc:any;
     if((docId>0)){     
       this.selectedDocumentId=docId;     
         let selectedParticipantJson=  this.participantArray.find(m=>m.documentID==this.selectedDocumentId);
              if(selectedParticipantJson==undefined){
                selectedParticipantJson=  this.participantJson.find(m=>m.documentID==this.selectedDocumentId);
              }

           if(selectedParticipantJson){
             this.particiantJsonList=JSON.parse(selectedParticipantJson.participantJson);   
             let newDoc = this.projectDocumentsDetailsList.find(e=>e.projectDocumentID == this.selectedDocumentId);
              this.imageHeight=newDoc.imageHeight;           
              this.imageWidth=newDoc.imageWidth; 
              this.UnChnagedparticipantJsonList=JSON.parse(JSON.stringify(this.particiantJsonList));
           }     
           else{
            let partcipantJsonn=  this.participantJson.find(m=>m.documentID==this.selectedDocumentId);
            if(partcipantJsonn==undefined){
              let images=this.projectDocumentImagesList.filter(m=>m.documentID==this.selectedDocumentId); 
              images.forEach(e => {
                this.particiantJsonList.push({img: e.pageImageUrl,fields: [],projectParticipantJsonID:0})
              });
            let newDoc = this.projectDocumentsDetailsList.find(e=>e.projectDocumentID == this.selectedDocumentId);
              this.imageHeight=newDoc.imageHeight;           
              this.imageWidth=newDoc.imageWidth; 
              this.UnChnagedparticipantJsonList=JSON.parse(JSON.stringify(this.particiantJsonList));
            }
            else{
            this.particiantJsonList=JSON.parse(partcipantJsonn.participantJson);
            let newDoc = this.projectDocumentsDetailsList.find(e=>e.projectDocumentID == this.selectedDocumentId);
              this.imageHeight=newDoc.imageHeight;           
              this.imageWidth=newDoc.imageWidth; 
            if(partcipantJsonn.hasCompleted==null)
            this.IsSigningComplete = false;
            else
             this.IsSigningComplete = partcipantJsonn.hasCompleted;
            }
            this.UnChnagedparticipantJsonList=JSON.parse(JSON.stringify(this.particiantJsonList));
           }
     document.getElementsByClassName('docSign')[0].scrollTop = 0;
   }
   else{
     this.selectedDocumentId = this.projectDocumentsDetailsList[0].projectDocumentID;
     let Current=this.participantJson.find(m=>
      m.documentID==this.selectedDocumentId);
      let newDoc = this.projectDocumentsDetailsList.find(e=>e.projectDocumentID == this.selectedDocumentId);
      this.imageHeight=newDoc.imageHeight;           
      this.imageWidth=newDoc.imageWidth; 
      if(Current==undefined){     
        this.particiantJsonList=[];
        let images=this.projectDocumentImagesList.filter(m=>m.documentID==this.selectedDocumentId); 
        images.forEach(e => {
          this.particiantJsonList.push({img: e.pageImageUrl,fields: [],projectParticipantJsonID:0})
        });
        this.UnChnagedparticipantJsonList=JSON.parse(JSON.stringify(this.particiantJsonList));
      }
      else{
        this.particiantJsonList = [];
        var blankfield=[];
        blankfield= JSON.parse(Current.participantJson);
       
        var finalData=JSON.parse(Current.participantJson);

        finalData.map(function(entry) {
          entry.fields.map(function(fieldentry) {
            fieldentry.ShowtoolDetail =false;          
            return entry;
        });
      });

        blankfield=blankfield.map((a) => {
         a.fields=[]
          return a;
          });
          this.particiantJsonList = blankfield;
          setTimeout(() => {
            this.particiantJsonList = this.particiantJsonList.map((a) => {
            var fi = finalData.find((x) => x.img == a.img);
            if (fi.fields) {
            a.fields = fi.fields;
            }
            return a;
            });
            this.UnChnagedparticipantJsonList=JSON.parse(JSON.stringify(this.particiantJsonList));
            }, 500);
            
       // this.particiantJsonList = JSON.parse(Current.participantJson);  
      }
   
      document.getElementsByClassName('docSign')[0].scrollTop = 0;      
   }

  //  setTimeout(() => {
  //   if(!this.IsSigningComplete)
  //   this.fillForms(this.fillFormTemplate);
  //  },600);
  } 
  
  showAllFiles(){
    this.showFiles = !this.showFiles
  }
    
  drawonImg(){
  var canvases = document.getElementsByTagName("canvas"); 
  if(!this.IsSigningComplete){
    this.isDrawing = !this.isDrawing;  
      this.indicesDrawn.filter(j=>j.selectedDocumentId==this.selectedDocumentId).forEach(element=>{
        var canvas = element.index[0].canv as HTMLCanvasElement;
        if(!this.isDrawing){  
          var dataURL = canvas.toDataURL();  
          var imagsDrawn = [];
          
          var imgContainer = " <img id='canvasimg' style='z-index:1' style='position: absolute;left: 0px; top: 0px;' src='"+dataURL+"'>"
          imagsDrawn.push(imgContainer);
          var currntObj = this.particiantJsonList[element.index[0].key];
          if(currntObj.drawings!=undefined){
          if(currntObj.drawings.length>=0){
            this.previousdrawings.push(JSON.parse(JSON.stringify(currntObj.drawings)));
            currntObj.drawings.push(imgContainer);            
          }
        } else{  
            currntObj["drawings"]= imagsDrawn;
          }      
        }
      })
    }
 
  }

  setIndex(index,selectedDocumentId){
    this.canvasIndex = index;
    if(this.indicesDrawn.indexOf(index)<0)
    this.indicesDrawn.push({index:index,selectedDocumentId:selectedDocumentId});
  }

  Cleardrawing(){  
    this.indicesDrawn=[];
    this.isDrawing = !this.isDrawing;
  }
  
  setHeight(index:any){
    var imgHeight = document.getElementById("docHolding"+(index+1)) as HTMLImageElement;
    return imgHeight.offsetHeight;
  }
  
  setWidth(index:any){
    var imgHeight = document.getElementById("docHolding"+(index+1)) as HTMLImageElement;
    return imgHeight.offsetWidth;
  }

  fillForms(templateRef: TemplateRef<any>) {
    if(this.showAllRequiredControls){
    this.highlightRequiredControls();
    }
    this.particiantJsonListAutoFill=[];
    this.particiantJsonListAutoFillCore=[];
    this.particiantJsonListAutoFillCom=[];

    let counter =0;
// Put non selected docs in array for cancel functionality
this.nonSelectedDocJsonList=[];
this.participantArray.forEach(ml => {
  if(this.selectedDocumentId!==ml.documentID)
  {
    this.nonSelectedDocJsonList.push({participantJson:JSON.parse(ml.participantJson),documentID:ml.documentID});
  }
});

//
    // this.particiantJsonList.forEach(page => {
    //   let fieldstoFill=  page.fields.filter(x=>(x.folderID!='' && x.folderID!=undefined && x.folderID>0) && (x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId));
    //   if(fieldstoFill?.length>0)
    //   counter++;
    //   page.fields.forEach(e => {
        
    //   });
    // });
    
    let contactfieldCount=false;
    let contactFolder:any= [];

    contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
    let contactUniqueFields=[];
    this.participantArray.forEach(ml => {
    let currentJsonArray:any=[];
    if(this.selectedDocumentId==ml.documentID)
    currentJsonArray= JSON.parse(JSON.stringify(this.particiantJsonList));
    else
    currentJsonArray= JSON.parse(ml.participantJson);    
   currentJsonArray.forEach(page => {
      page.fields= page.fields.filter(x=>x.folderID==contactFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID==undefined || x.selectedParticipant?.groupRelationParticipantMappingID==0||x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId));
      let fieldHolder:any=[];
      page.fields.forEach(elem => {
        if(fieldHolder.length==0 && !contactUniqueFields.find(k=>k.fieldName==elem.fieldName && elem.folderID==contactFolder[0].folderID))
       { fieldHolder.push(elem);
        contactUniqueFields.push(elem);
      }
        else if(!contactUniqueFields.find(k=>k.fieldName==elem.fieldName && elem.folderID==contactFolder[0].folderID))
        {
          fieldHolder.push(elem);
          contactUniqueFields.push(elem);
        }
       contactfieldCount=true;

      });
      page.fields=fieldHolder;
    });
    if(this.particiantJsonListAutoFill.length==0)
    this.particiantJsonListAutoFill=currentJsonArray;
    else
    {
      currentJsonArray.forEach(vb => {
        this.particiantJsonListAutoFill.push(vb)
      });
    
    }
  });
    if(!contactfieldCount)
    {
      this.particiantJsonListAutoFill=[];
    }
  //

  //
    let corefieldCount=false;
    let coreUniqueFields=[];
    let coretFolder:any=[]; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));
  this.participantArray.forEach(ml => {
    let currentJsonArray:any=[];
    if(this.selectedDocumentId==ml.documentID)
    currentJsonArray= JSON.parse(JSON.stringify(this.particiantJsonList));
    else
    currentJsonArray= JSON.parse(ml.participantJson);
       
      currentJsonArray.forEach(page => {
      page.fields= page.fields.filter(x=>x.folderID==coretFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID==undefined || x.selectedParticipant?.groupRelationParticipantMappingID==0||x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId));
      let fieldHolder:any=[];
      page.fields.forEach(elem => {
        if(fieldHolder.length==0  && !coreUniqueFields.find(k=>k.fieldName==elem.fieldName && elem.folderID==coretFolder[0].folderID))
        {fieldHolder.push(elem);
          coreUniqueFields.push(elem);
        }
        else if(!coreUniqueFields.find(k=>k.fieldName==elem.fieldName && elem.folderID==coretFolder[0].folderID))
        {
          fieldHolder.push(elem);
          coreUniqueFields.push(elem);
        }
        if(elem.isDisabled==false)
           corefieldCount=true;
      });
      page.fields=fieldHolder;
    });
    if(this.particiantJsonListAutoFillCore.length==0)
    this.particiantJsonListAutoFillCore=currentJsonArray;
    else
    {
      currentJsonArray.forEach(vb => {
        this.particiantJsonListAutoFillCore.push(vb)
      });
    
    }
  });

    if(!corefieldCount)
    {
      this.particiantJsonListAutoFillCore=[];
    }
  //

    //
     let comfieldCount=false;
     let comUniqueFields=[];
     let comFolder:any=[];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
     comFolder.push(this.fieldFolders.find(n=>n.name=='Company'));
     this.participantArray.forEach(ml => {
      let currentJsonArray:any=[];
      if(this.selectedDocumentId==ml.documentID)
      currentJsonArray= JSON.parse(JSON.stringify(this.particiantJsonList));
      else
      currentJsonArray= JSON.parse(ml.participantJson);
         
        currentJsonArray.forEach(page => {
        page.fields= page.fields.filter(x=>x.folderID==comFolder[0].folderID && (x.selectedParticipant?.groupRelationParticipantMappingID==undefined || x.selectedParticipant?.groupRelationParticipantMappingID==0||x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId));
        let fieldHolder:any=[];
        page.fields.forEach(elem => {
          if(fieldHolder.length==0  && !comUniqueFields.find(k=>k.fieldName==elem.fieldName && elem.folderID==comFolder[0].folderID))
          {fieldHolder.push(elem);
            comUniqueFields.push(elem);
          }
          else if(!comUniqueFields.find(k=>k.fieldName==elem.fieldName && elem.folderID==comFolder[0].folderID))
          {
            fieldHolder.push(elem);
            comUniqueFields.push(elem);
          }
          comfieldCount=true;
        });
        page.fields=fieldHolder;
      });
      if(this.particiantJsonListAutoFillCom.length==0)
      this.particiantJsonListAutoFillCom=currentJsonArray;
      else
      {
        currentJsonArray.forEach(vb => {
          this.particiantJsonListAutoFillCom.push(vb)
        });
      
      }
    });
    if(!comfieldCount)
    {
      this.particiantJsonListAutoFillCom=[];
    }
  //
  this.particiantJsonListAutoFillBeforFill=this.particiantJsonListAutoFill;
  this.particiantJsonListAutoFillCoreBeforFill=this.particiantJsonListAutoFillCore;
  this.particiantJsonListAutoFillComBeforFill=this.particiantJsonListAutoFillCom;
  if(this.particiantJsonListAutoFill.length>0 && this.groupRelationParticipantId!=0)
  {
   this.openPanel=1;
  }
  else if(this.particiantJsonListAutoFillCore.length>0)
  {
    this.openPanel=2;
  }
  else if(this.particiantJsonListAutoFillCom.length>0)
  {
    this.openPanel=3;
  }
  if(this.particiantJsonListAutoFill.length==0 && this.particiantJsonListAutoFillCore.length==0)
     { 
       return;
     }
    if((contactfieldCount && this.groupRelationParticipantId!=0) || corefieldCount || comfieldCount){
    this.beforeFillForm = JSON.parse(JSON.stringify(this.particiantJsonList));
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
    }
  }

  onAutoFillChanged(event){

    this.autoFill = true;
    //this.getFieldValuesForAutoFill();
    this.getFieldValuesForAutoFillCore();

    // if(event.checked){
    //   this.getFieldValuesForAutoFill();
    //   this.getFieldValuesForAutoFillCore();
    // }
    // else{
    //   this.particiantJsonListAutoFill =this.particiantJsonListAutoFillBeforFill;
    //   this.particiantJsonListAutoFillCore =this.particiantJsonListAutoFillCoreBeforFill;
    //   this.particiantJsonListAutoFillCom=this.particiantJsonListAutoFillComBeforFill;
    // }
  }
   
  getFieldValuesForAutoFill(){
    let reqModel ={
     groupParticipantRelationId: this.groupRelationParticipantId,
     databaseID: Number(this.databaseId),
     organizationID: this.organizationId
    };
    
	 let contactFolder:any= []//folderAccess.find(b=>b.folderName=='Contact');
   contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
    this.formsService.getFieldValuesForAutoFill(reqModel).subscribe(response=>{
      this.autofillvalues = response.data;
      this.particiantJsonListAutoFill.map((entry)=>{
        entry.fields.filter(x=>x.folderID==contactFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId).forEach((field) => {
          if(field.fieldTypeName=="Checkbox" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
            field.defaultValue.split(',').forEach((value,key)=>{
              if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
              this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
                if(field.chkSelectedValues.length==0)
                field.chkSelectedValues.push("ctrl-"+(key));
                else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
                {
                  field.chkSelectedValues.push("ctrl-"+(key));
                }
              }
         })
        }
        if(field.fieldTypeName=="radio" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
          field.defaultValue.split(',').forEach((value,key)=>{
            if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
            this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
              if(field.rbSelectedValues.length==0)
              field.rbSelectedValues.push("ctrl-"+(key));
              else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
              {
                field.rbSelectedValues.push("ctrl-"+(key));
              }
            }
       })
      }
      if(field.fieldTypeName==="MultiSelect")
      {

        if(Array.isArray(this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue) &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.length>0)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue?.split(',');
       }
       else if(field.fieldName==="Address" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===0 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue;
        }
      else if(field.fieldName==="City"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===3|| field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue;
        
      }
      else if(field.fieldName==="State"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==''){
       if(field.childFieldType===2 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue;
      }
      else if(field.fieldName==="Zip" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===4 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue;
     }
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
          field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
           
    });
      });

      this.particiantJsonList.map((entry)=>{
        entry.fields.filter(x=>x.folderID ==contactFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId).forEach((field) => {
          if(field.fieldTypeName=="Checkbox" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
            field.defaultValue.split(',').forEach((value,key)=>{
              if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
              this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
                if(field.chkSelectedValues.length==0)
                field.chkSelectedValues.push("ctrl-"+(key));
                else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
                {
                  field.chkSelectedValues.push("ctrl-"+(key));
                }
              }
         })
        }
        if(field.fieldTypeName=="radio" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
          field.defaultValue.split(',').forEach((value,key)=>{
            if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
            this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
              if(field.rbSelectedValues.length==0)
              field.rbSelectedValues.push("ctrl-"+(key));
              else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
              {
                field.rbSelectedValues.push("ctrl-"+(key));
              }
            }
       })
      }
      if(field.fieldTypeName==="MultiSelect")
      {

        if(Array.isArray(this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue) &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.length>0)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue?.split(',');
       }
       else if(field.fieldName==="Address" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===0 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue;
        }
      else if(field.fieldName==="City"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===3|| field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue;
        
      }
      else if(field.fieldName==="State"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==''){
       if(field.childFieldType===2 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue;
      }
      else if(field.fieldName==="Zip" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===4 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue;
     }
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
          field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
       
        });
      });
      // auto fill other jsons and save
      
      this.participantArray.forEach(ml => {
        let jsonelement:any;
       if(this.selectedDocumentId!==ml.documentID)
       {
        jsonelement=JSON.parse(ml.participantJson);

       jsonelement.map((entry)=>{
         entry.fields.filter(x=>x.folderID==contactFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId).forEach((field) => {
          if(field.fieldTypeName=="Checkbox" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
            field.defaultValue.split(',').forEach((value,key)=>{
              if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
              this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
                if(field.chkSelectedValues.length==0)
                field.chkSelectedValues.push("ctrl-"+(key));
                else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
                {
                  field.chkSelectedValues.push("ctrl-"+(key));
                }
              }
         })
        }
        if(field.fieldTypeName=="radio" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
          field.defaultValue.split(',').forEach((value,key)=>{
            if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
            this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
              if(field.rbSelectedValues.length==0)
              field.rbSelectedValues.push("ctrl-"+(key));
              else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
              {
                field.rbSelectedValues.push("ctrl-"+(key));
              }
            }
       })
      }
      if(field.fieldTypeName==="MultiSelect")
      {

        if(Array.isArray(this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue) &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.length>0)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue?.split(',');
       }
       else if(field.fieldName==="Address" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===0 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue;
        }
      else if(field.fieldName==="City"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===3|| field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue;
        
      }
      else if(field.fieldName==="State"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==''){
       if(field.childFieldType===2 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue;
      }
      else if(field.fieldName==="Zip" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===4 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue;
     }
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
          field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
           
          });
       });
       ml.participantJson=JSON.stringify(jsonelement);
      }

    });
    });
  }

  getFieldValuesForAutoFillCore(){    
    let coretFolder:any=[]; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));

    let reqModel ={
     groupParticipantRelationId: this.groupRelationParticipantId,
     databaseID: Number(this.databaseId),
     organizationID: this.organizationId,
     folderID:coretFolder[0].folderID,
     projectID:this.projectID,
     IsTabularForm:true,
    };
    this.formsService.getFieldValuesForAutoFillCore(reqModel).subscribe(response=>{
      this.autofillvalues = response.data;
      this.particiantJsonListAutoFillCore.map((entry)=>{
        entry.fields.filter(x=>x.folderID ==coretFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId).forEach((field) => {
          if(field.fieldTypeName=="Checkbox" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
            field.defaultValue.split(',').forEach((value,key)=>{
              if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
              this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
                if(field.chkSelectedValues.length==0)
                field.chkSelectedValues.push("ctrl-"+(key));
                else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
                {
                  field.chkSelectedValues.push("ctrl-"+(key));
                }
              }
         })
        }
        if(field.fieldTypeName=="radio" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
          field.defaultValue.split(',').forEach((value,key)=>{
            if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
            this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
              if(field.rbSelectedValues.length==0)
              field.rbSelectedValues.push("ctrl-"+(key));
              else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
              {
                field.rbSelectedValues.push("ctrl-"+(key));
              }
            }
       })
      }
      if(field.fieldTypeName==="MultiSelect")
      {

        if(Array.isArray(this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue) &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.length>0)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue?.split(',');
       }
       else if(field.fieldName==="Address" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===0 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue;
        }
      else if(field.fieldName==="City"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===3|| field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue;
        
      }
      else if(field.fieldName==="State"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==''){
       if(field.childFieldType===2 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue;
      }
      else if(field.fieldName==="Zip" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===4 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue;
     }
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
          field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
       
        });
      });

      this.particiantJsonList.map((entry)=>{
        entry.fields.filter(x=>x.folderID ==coretFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId).forEach((field) => {
          if(field.fieldTypeName=="Checkbox" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
            field.defaultValue.split(',').forEach((value,key)=>{
              if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
              this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
                if(field.chkSelectedValues.length==0)
                field.chkSelectedValues.push("ctrl-"+(key));
                else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
                {
                  field.chkSelectedValues.push("ctrl-"+(key));
                }
              }
         })
        }
        if(field.fieldTypeName=="radio" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
          field.defaultValue.split(',').forEach((value,key)=>{
            if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
            this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
              if(field.rbSelectedValues.length==0)
              field.rbSelectedValues.push("ctrl-"+(key));
              else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
              {
                field.rbSelectedValues.push("ctrl-"+(key));
              }
            }
       })
      }
      if(field.fieldTypeName==="MultiSelect")
      {

        if(Array.isArray(this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue) &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.length>0)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue?.split(',');
       }
       else if(field.fieldName==="Address" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===0 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue;
        }
      else if(field.fieldName==="City"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===3|| field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue;
        
      }
      else if(field.fieldName==="State"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==''){
       if(field.childFieldType===2 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue;
      }
      else if(field.fieldName==="Zip" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==''){
        if(field.childFieldType===4 || field.childFieldType==undefined)
        field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue;
     }
      else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
          field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
       
        });
      });
        // auto fill other jsons and save
        this.participantArray.forEach(ml => {
          let jsonelement:any;
          if(this.selectedDocumentId!==ml.documentID)
          {
           jsonelement=JSON.parse(ml.participantJson);

           jsonelement.map((entry)=>{
            entry.fields.filter(x=>x.folderID ==coretFolder[0].folderID && x.selectedParticipant?.groupRelationParticipantMappingID==this.groupRelationParticipantId).forEach((field) => {
              if(field.fieldTypeName=="Checkbox" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
                field.defaultValue.split(',').forEach((value,key)=>{
                  if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
                  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
                    if(field.chkSelectedValues.length==0)
                    field.chkSelectedValues.push("ctrl-"+(key));
                    else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
                    {
                      field.chkSelectedValues.push("ctrl-"+(key));
                    }
                  }
             })
            }
            if(field.fieldTypeName=="radio" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==''){
              field.defaultValue.split(',').forEach((value,key)=>{
                if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!='' &&
                this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.split(',').find(m=> m==value)==value){
                  if(field.rbSelectedValues.length==0)
                  field.rbSelectedValues.push("ctrl-"+(key));
                  else if(!field.chkSelectedValues.find(m=>m=="ctrl-"+(key)))
                  {
                    field.rbSelectedValues.push("ctrl-"+(key));
                  }
                }
           })
          }
          if(field.fieldTypeName==="MultiSelect")
          {
    
            if(Array.isArray(this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue) &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue.length>0)
            field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
          else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
            field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue?.split(',');
           }
           else if(field.fieldName==="Address" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue!==''){
            if(field.childFieldType===0 || field.childFieldType==undefined)
            field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==0 && d.fieldValue!="")?.fieldValue;
            }
          else if(field.fieldName==="City"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue!==''){
            if(field.childFieldType===3|| field.childFieldType==undefined)
            field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==3 && d.fieldValue!="")?.fieldValue;
            
          }
          else if(field.fieldName==="State"&&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue!==''){
           if(field.childFieldType===2 || field.childFieldType==undefined)
            field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==2 && d.fieldValue!="")?.fieldValue;
          }
          else if(field.fieldName==="Zip" &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue!==''){
            if(field.childFieldType===4 || field.childFieldType==undefined)
            field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID && d.childFieldType==4 && d.fieldValue!="")?.fieldValue;
         }
          else if(this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!==undefined &&  this.autofillvalues.find(d=>d.fieldID==field.fieldID)?.fieldValue!=='')
              field.selectedValue = this.autofillvalues.find(d=>d.fieldID==field.fieldID && d.folderID==field.folderID)?.fieldValue;
           
            });
          });
           
           ml.participantJson=JSON.stringify(jsonelement);
          }
        });
    });
  }

  keyPress(event) {
   this.declineButtonShow=true;
  }

  declineForm(){
    if(this.reasonToDecline.trim()!==""){
      let reqModel ={
        groupParticipantRelationId: this.groupRelationParticipantId,
        reasonToDecline:this.reasonToDecline.trim(),  
        organizationID: this.organizationId,
        databaseID: Number(this.databaseId),
        };
        this.formsService.declineForm(reqModel).subscribe(resposne=>{
          if(resposne.data==1){
            this.IsSigningComplete=true;
            this.declineButtonShow=false;
            this.AddProjectEventLog(5,"Declined by "+'('+ this.participantEmailId+')'); 
            //Send=1, View=2, Sign=3, Complete=4, Decline=5, Assign=6
            this.toastr.info("Form declined sucessfully.");
            this.dialog.closeAll();
          }
        });
    }else{
      this.toastr.warning("Please enter reason to decline.");
    }
  
  }

  clearForm(){   
   // Clear form from Actions after Add Textbox/Signature/Initials
    this.particiantJsonList.map((entry) =>{
      entry.fields.map((fieldentry)=> {     
           if(fieldentry.fieldTypeName=="Textbox" && fieldentry.filledData==false
           &&  fieldentry.Control =="Static"){
            fieldentry.selectedValue="";
          }
          else if(fieldentry.fieldTypeName=="Signature"){
            fieldentry.signatureBase64="";
            fieldentry.signatureText="" ;
            fieldentry.ImageData=[];
            
          }
          else if(fieldentry.fieldTypeName=="Initials"){
            fieldentry.ImageData=[];
            fieldentry.signatureBase64="";
            fieldentry.signatureText="" ;
            fieldentry.ImageData=[];
          }
      else{
      }
    });
    });
  
    this.particiantJsonList.map((entry) =>{
      entry.fields.map((fieldentry)=> {      
        if((fieldentry.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId
          && fieldentry.filledData!=true)){        
          fieldentry.selectedValue="";          
          
          if((fieldentry.fieldTypeName=="Textbox")||(fieldentry.fieldTypeName=="Number")||(fieldentry.fieldTypeName=="Textarea")||(fieldentry.fieldTypeName=="Dropdown")){
            fieldentry.selectedValue="";
          }         
         else if((fieldentry.fieldTypeName=="CheckBoxGroup")||(fieldentry.fieldTypeName=="Checkbox")){
          fieldentry.chkSelectedValues=[];
          }
          else if((fieldentry.fieldTypeName=="Radio")){
            fieldentry.rbSelectedValues=[];
          }
         else  if(fieldentry.fieldTypeName=="Location"){
          fieldentry.Lat="";
          fieldentry.Long="";          
          }
          else if(fieldentry.fieldTypeName=="Signature"){
            fieldentry.signatureBase64="";
          }
          else if(fieldentry.fieldTypeName=="Initials"){
            fieldentry.ImageData=[];
            fieldentry.signatureBase64="";
          }
          else if(fieldentry.fieldTypeName=="Image"){
            fieldentry.ImageData=[];
          }
          else if(fieldentry.fieldTypeName=="File"){
            fieldentry.FileData=[];
          }
          else if(fieldentry.fieldTypeName=="Draw"){
            fieldentry.drawBase64="";
          }         
        }   
      else{
      }
    });
    }); 
  }

  fillRequrieds(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  assignOther(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  declineProject(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }
  
  otherFieldAssigned(templateRef: TemplateRef<any>,OtherFieldAssignedRef:TemplateRef<any>) {
   
    this.dialog.open(OtherFieldAssignedRef,{
      panelClass: 'selectParticipants',
    });
  }

  ifOtherAssignedFieldsFilled(){
    let fieldVal=false;
    this.docstoFill=[];
    let particiantJsonListLeftFieldCheck:any=[];
    this.participantArray.find(n=>n.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
    this.participantArray.forEach(element => {
      particiantJsonListLeftFieldCheck=[];
      particiantJsonListLeftFieldCheck.push(JSON.parse(element.participantJson));
      particiantJsonListLeftFieldCheck.forEach(e => {
        e.forEach(ef => {
        ef.fields.forEach(field => {
          if(field.selectedParticipant?.groupRelationParticipantMappingID===this.groupRelationParticipantId)
          {
            if(field.fieldTypeName=="Checkbox" || field.fieldTypeName=='CheckBoxGroup'){
              if(field.chkSelectedValues==undefined || field.chkSelectedValues.length==0)
              {
                 fieldVal=true;
                 if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 }
              }
            }
         else if(field.fieldTypeName=="Radio"){
            if(field.rbSelectedValues==undefined || field.rbSelectedValues.length==0)
              { fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
              }
           }  
         else if(field.fieldTypeName==="MultiSelect")
          {
            if(field.selectedValue=="" || field.selectedValue==undefined)
            {
              if (Array.isArray(field.selectedValue))
               {
                 if(field.selectedValue.length==0)
                 {
                fieldVal=true;
                if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
                }
               }
               else
               {
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
              }
            }
          }
          else if(field.fieldTypeName=='File')
          {
            if(field.FileData.length==0)
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=='Image')
          {
            if(field.ImageData.length==0)
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=='Location')
          {
            if(field.Lat=='' || field.Long=='')
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=="Draw")
          {
            if(field.drawBase64=='' || field.drawBase64==undefined )
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=="Signature")
          {
            if((field.signatureBase64=='' || field.signatureBase64==undefined) && (field.signatureText=='' || field.signatureText==undefined) && (field.ImageData.length==0)  )
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=="Initials")
          {
            if((field.signatureBase64=='' || field.signatureBase64==undefined) && (field.signatureText=='' || field.signatureText==undefined) && (field.ImageData.length==0)  )
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=="Table")
          {
            if(this.checkifTableIsEmpty(field.fillList))
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          // else
          // { 
          //   if(field.fieldTypeName!='BulletList')
          //   if(field.selectedValue=="" || field.selectedValue==undefined)
          //   {
          //     fieldVal=true;
          //     if(!this.docstoFill.find(h=>h.documentID==element.documentID))
          //        {
          //         this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
          //        }
          //   }
          // }
          }
        });
      });
    });
    });
 return fieldVal;
  }
  checkifTableIsEmpty(lst:any)
  {
    let check =false;
    lst.forEach(e => {
      if(e.val=='' || e.val==undefined)
      {
        check=true;
      }
    });
return check;
  }
  
  SignatureAcceptance(templateRef: TemplateRef<any>,OtherFieldAssignedRef:TemplateRef<any>,requiredFieldAssigned:TemplateRef<any>) {
    if(this.ifRequiredFieldsFilled())
    { 
      this.dialog.open(requiredFieldAssigned,{
      panelClass: 'selectParticipants',
    });
      return;
    }
    // if(this.ifOtherAssignedFieldsFilled())
    // {
    //   this.otherFieldAssigned(templateRef,OtherFieldAssignedRef);
    //   return;
    // }
    this.isAcceptButtonDisabled= false;
    this.innerhtmlvalue = document.getElementById("docSign").innerHTML;
    if(this.AllDocsHtml.find(x=>x.docId==this.selectedDocumentId)==undefined)
    this.AllDocsHtml.push({innerHtmlval:document.getElementById("docSign").innerHTML,docId:this.selectedDocumentId});
    else{
      var ele = this.AllDocsHtml.find(x=>x.docId==this.selectedDocumentId);
      ele.innerHtmlval=document.getElementById("docSign").innerHTML;
    }
    var drwImgContainrt = document.getElementById("imageDrawContainer");
    if(drwImgContainrt!=null){
      this.drawingImgeHeight = drwImgContainrt.offsetHeight.toString();
    }
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  SignatureAcceptanceFInal(templateRef: TemplateRef<any>) {
    this.dialog.closeAll();
    this.isAcceptButtonDisabled= false;
    this.innerhtmlvalue = document.getElementById("docSign").innerHTML;
    if(this.AllDocsHtml.find(x=>x.docId==this.selectedDocumentId)==undefined)
    this.AllDocsHtml.push({innerHtmlval:document.getElementById("docSign").innerHTML,docId:this.selectedDocumentId});
    else{
      var ele = this.AllDocsHtml.find(x=>x.docId==this.selectedDocumentId);
      ele.innerHtmlval=document.getElementById("docSign").innerHTML;
    }
    var drwImgContainrt = document.getElementById("imageDrawContainer");
    if(drwImgContainrt!=null){
      this.drawingImgeHeight = drwImgContainrt.offsetHeight.toString();
    }
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  ifRequiredFieldsFilled(){
    let fieldVal=false;
    this.docstoFill=[];
    let particiantJsonListLeftFieldCheck:any=[];
    
    this.participantArray.find(n=>n.documentID==this.selectedDocumentId).participantJson=JSON.stringify(this.particiantJsonList);
    this.participantArray.forEach(element => {
      particiantJsonListLeftFieldCheck=[];
      particiantJsonListLeftFieldCheck.push(JSON.parse(element.participantJson));
      particiantJsonListLeftFieldCheck.forEach(e => {
        e.forEach(ef => {
        ef.fields.forEach(field => {
          if(field.selectedParticipant?.groupRelationParticipantMappingID===this.groupRelationParticipantId && field.isRequired)
          {
            if(field.fieldTypeName=="Checkbox" || field.fieldTypeName=='CheckBoxGroup'){
              if(field.chkSelectedValues==undefined || field.chkSelectedValues.length==0)
                 fieldVal=true;
                 if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 }
            }
          if(field.fieldTypeName=="radio"){
            if(field.rbSelectedValues==undefined || field.rbSelectedValues.length==0)
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
           }  
           if(field.fieldTypeName=="Textbox"){
            if(field.selectedValue==undefined || field.selectedValue=='')
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
           }  
           if(field.fieldTypeName=="measure"){
            if(field.width==undefined || field.width=='' || field.width==0 || field.width=='0')
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
           } 
           if(field.fieldTypeName=="Time"){
            if(field.selectedValue==undefined || field.selectedValue=='')
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
           } 
           if(field.fieldTypeName=="Date"){
            if(field.selectedValue==undefined || field.selectedValue=='')
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
           } 
           if(field.fieldTypeName=="Number"){
            if(field.selectedValue==undefined || field.selectedValue=='')
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
           } 
           if(field.fieldTypeName=="Dropdown"){
            if(field.selectedValue==undefined || field.selectedValue=='')
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
           }  
           if(field.fieldTypeName=="Textarea"){
            if(field.selectedValue==undefined || field.selectedValue=='')
               fieldVal=true;
               if(!this.docstoFill.find(h=>h.documentID==element.documentID))
               {
                this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
               }
           } 
          if(field.fieldTypeName==="MultiSelect")
           {
             if(field.selectedValue=="" || field.selectedValue==undefined)
             {
               if (Array.isArray(field.selectedValue))
                {
                  if(field.selectedValue.length==0)
                  {
                 fieldVal=true;
                 if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                  {
                   this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                  
                  }
                 }
                }
                else
                {
                fieldVal=true;
                if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                  {
                   this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                  
                  }
               }
             }
           }
          if(field.fieldTypeName=='File')
          {
            if(field.FileData.length==0)
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          if(field.fieldTypeName=='Image')
          {
            if(field.ImageData.length==0)
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          if(field.fieldTypeName=='Location')
          {
            if(field.Lat=='' || field.Long=='')
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          
          else if(field.fieldTypeName=="Draw")
          {
            if(field.drawBase64=='' || field.drawBase64==undefined )
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=="Signature")
          {
            if((field.signatureBase64=='' || field.signatureBase64==undefined) && (field.signatureText=='' || field.signatureText==undefined) && (field.ImageData.length==0)  )
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=="Initials")
          {
            if((field.signatureBase64=='' || field.signatureBase64==undefined) && (field.signatureText=='' || field.signatureText==undefined) && (field.ImageData.length==0)  )
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          else if(field.fieldTypeName=="Table")
          {
            if(this.checkifTableIsEmpty(field.fillList))
            {
              fieldVal=true;
              if(!this.docstoFill.find(h=>h.documentID==element.documentID))
                 {
                  this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
                 }
            }
          }
          // else
          // { 
          //   if(field.fieldTypeName!='BulletList')
          //   if(field.selectedValue=="" || field.selectedValue==undefined)
          //   {
          //     fieldVal=true;
          //     if(!this.docstoFill.find(h=>h.documentID==element.documentID))
          //        {
          //         this.docstoFill.push({documentID:element.documentID,name:this.UnChnagedparticipantJsonListArray.find(g=>g.documentID==element.documentID).name})
                 
          //        }
          //   }
          // }
          }
        });
      });
    });
    });
 return fieldVal;
  }

  fetchLocation(data,id) {
    if (window.navigator && window.navigator.geolocation) {
      window.navigator.geolocation.getCurrentPosition(
          position => {
              this.geolocationPosition = position
              if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
                this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).Lat
                =this.geolocationPosition!==undefined && this.geolocationPosition!==null && this.geolocationPosition!==''? this.geolocationPosition.coords.latitude:'';
                this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).Long
                =this.geolocationPosition!==undefined && this.geolocationPosition!==null && this.geolocationPosition!==''?this.geolocationPosition.coords.longitude:'';

                var field =  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id);
                if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID==0)
                {
                    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
                }
                //
                this.particiantJsonList.forEach(element => {
                  element.fields.forEach(fe => {
                   if(fe.fieldName==field.fieldName && fe.folderID==field.folderID)
                   {
                     fe.Lat=field.Lat;
                     fe.Long=field.Long;
                   }
                  });
                });
                //
                if(field.selectedParticipant?.groupRelationParticipantMappingID==0){
                  this.assignFilledUnassignedControls(field);
                }
              }
          },
          error => {
              switch (error.code) {
                  case 1:
                     
                      break;
                  case 2:
                    
                      break;
                  case 3:
                   
                      break;
              }
          }
      );
  };
  }
 
  onSelectFile(event,data: any,id) {
  this.projectDocumentImagesList;
  this.projectDocumentsDetailsList;
 
  var ProjectDocumentID= this.projectDocumentImagesList.filter(x => x.pageImageUrl == data.img);
  var documentId= ProjectDocumentID[0].documentID;
  var filename = event.target.files;
  for (let i = 0; i < filename.length; i++){
    var ext = filename[i].name.split('.').pop();
    const file = event.target.files[i];
    
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      var FullPath = filename[i].name;
      var documentNameSplit = FullPath.split('.');
      var documentName = documentNameSplit[0];
      var documenttype = documentNameSplit[1];

      var base64String = reader.result;  
      var projectDocumentIDFromResponse;
      this.responseArray;
      this.formData = new FormData();
      this.formData.append('UserID', this.responseArray.userID);
      this.formData.append('ProjectName', this.responseArray.projectName);
      this.formData.append('ProjectID', this.responseArray.projectID);
      this.formData.append('ProjectDocumentID', "0");
      this.formData.append('ParentDocumentID', documentId);
      this.formData.append('DocumentName', documentName);
      this.formData.append('file', event.target.files[i]);
      this.formData.append('DocumentType', documenttype);    
      this.formData.append('DatabaseID', this.responseArray.databaseID);
      this.formData.append('OrganizationID', this.responseArray.organizationID);
      this.formsService.AddProjectAttachmentDocument(this.formData).subscribe((response) => {
        if (response != undefined) {          
          projectDocumentIDFromResponse= response.data.projectDocumentID;
          var FileObj =[];
          FileObj.push({
            FullPath:FullPath,
            FileName: documentName,
            FileExtention: documenttype,
            FilePath:filename[i],
            Base64String:base64String,
            projectDocumentID:projectDocumentIDFromResponse
        });      
         if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
         let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).FileData = FileObj  
         if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID==0)  
         {
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
         }  
         this.particiantJsonList = this.particiantJsonList;
        }
        }else{ 
        }
      }); 
    }  
   }    
  }


  getColumnValue(data:any,tblId:any,row:any,col:any) {
  let id ='txt-'+row+col;
  let val='';
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    val=  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == tblId).fillList.find(m=>m.id==id).val;
  }
  return val;
  }

  OpentoolDetailtbl (data: any, id) {
    return;
  if(!this.controlAlignArray.find(m=>m.id==id)){
  this.controlAlignArray.push({
    fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
    img:data.img,
    id:id
  });
}
 this.tbldata=data;
 this.tblid=id;

 var check = data.fields.filter((s) => s.id ==id);
 if(check.length > 0 ){
  this.tblrowsnumber = check[0].rows.length;
  this.tblclmnumber = check[0].column.length;
 }
  }


  onTableChange(e: any, data: any, id) {
    if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID==0)
     {
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
     }
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList.find(m=>m.id==e.target.id).val = e.target.value == undefined ? '' : e.target.value;
    this.particiantJsonList = this.particiantJsonList;
   }    

  }

  OpentoolDetailDropDown (data: any, id) {
  return;
  if(!this.controlAlignArray.find(m=>m.id==id)){
  this.controlAlignArray.push({
    fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
    img:data.img,
    id:id
  });
}
this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
  if(element.id!=id)
  element.ShowtoolDetail = false;
});
  if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
    var getData = FieldsDetails.fields.filter(x => x.id ===  id);
    if(getData.length > 0){
      if(getData[0].fieldTypeName == "Dropdown" ){
        this.dropdownFieldArray= getData[0].fillList;          
      }
      if(getData[0].fieldID > 0 ){
       this.dropdownddisabled =true;      
      }else{
        this.dropdownddisabled =false;
      }
      this.text = getData[0].selectedValue;
      this.ControlData = FieldsDetails;
      this.ControlId = id;
      this.isRequired = getData[0].isRequired;
      this.readonly = getData[0].readonly;
      this.characterlimit = getData[0].charLimit;
      this.textColor = getData[0].fontColor;
      var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
      this.fontsize = Number(size);
      this.fontstyle = getData[0].fontstyle;
      this.fontweight = getData[0].fontweight;
      this.textdecoration = getData[0].textdecoration;
      this.fontfamily = getData[0].fontfamily; 
      this.textalign= getData[0].textalign;   
    }    
  }
  }


  setDdlValue(e: any, data: any, field) {
    if(Array.isArray(e.value))
    {
     // e.value=e.value.join(",");
    }
    
	 let selectedCtrlFolderID= field.folderID;
   field.selectedValue=e.value;
let fieldParticipantID= field.selectedParticipant?.groupRelationParticipantMappingID;
fieldParticipantID=(fieldParticipantID==undefined ?0:fieldParticipantID);

	 let contactFolder:any= []//folderAccess.find(b=>b.folderName=='Contact');
   contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==contactFolder[0].folderID &&this.particiantJsonListAutoFill.find(x => x.img == data.img)) {
      if(this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
       this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;
      
      //let field =  this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id);
      
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID)
        {
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
               fe.selectedValue=field.selectedValue;
             }
            });
          });
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
        {
       this.particiantJsonList.forEach(element => {
         element.fields.forEach(fe => {
          if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
          {
            fe.selectedValue=field.selectedValue;
          }
         });
       });
      }
      });
    }
    let coretFolder:any=[]; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==coretFolder[0].folderID &&this.particiantJsonListAutoFillCore.find(x => x.img == data.img)) {
      if(this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
       this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;
      
      //let field =  this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == id);
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID)
        {
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
               fe.selectedValue=field.selectedValue;
             }
            });
          });
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
        {
       this.particiantJsonList.forEach(element => {
         element.fields.forEach(fe => {
          if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
          {
            fe.selectedValue=field.selectedValue;
          }
         });
       });
      }
      });
    }

    let comFolder:any=[];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
    comFolder.push(this.fieldFolders.find(n=>n.name=='Company'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==comFolder[0].folderID &&this.particiantJsonListAutoFillCom.find(x => x.img == data.img)) {
      if(this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
      this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;
     
      //let field =  this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == id);
     
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID)
        {
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
               fe.selectedValue=field.selectedValue;
             }
            });
          });
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
        {
       this.particiantJsonList.forEach(element => {
         element.fields.forEach(fe => {
          if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
          {
            fe.selectedValue=field.selectedValue;
          }
         });
       });
      }
      });
    }

    if (fieldParticipantID==this.groupRelationParticipantId && ((selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
    || (selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
     || (selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0)))
   {
    if(this.particiantJsonList.find(x => x.img == data.img)!==undefined)
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;

   }
   else if(this.particiantJsonList.find(x => x.img == data.img)!==undefined && this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID==0)
     {
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
     }
     else if(this.particiantJsonList.find(x => x.img == data.img)!==undefined && this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID>0)
     {
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = e.value;
     }
  }

  
  filedsForFillForm(fields){ 
    return fields.filter(x=>x.folderName!='');
  }


  cancelFillForm(){
    this.particiantJsonListAutoFill = this.beforeFillForm;
    this.particiantJsonList.forEach(element => {
      element.fields.forEach(fe => {
       if(this.beforeFillForm.find(m=>m.img===element.img).fields.find(me=>me.folderID===fe.folderID && fe.fieldName===me.fieldName))
       {
         if(this.beforeFillForm.find(m=>m.img===element.img).fields.find(me=>me.folderID===fe.folderID && fe.fieldName===me.fieldName && fe.id===me.id)!=undefined)
         {
           
         fe.selectedValue=this.beforeFillForm.find(m=>m.img===element.img).fields.find(me=>me.folderID===fe.folderID && fe.fieldName===me.fieldName && fe.id===me.id).selectedValue;
         fe.chkSelectedValues =this.beforeFillForm.find(m=>m.img===element.img).fields.find(me=>me.folderID===fe.folderID && fe.fieldName===me.fieldName && fe.id===me.id).chkSelectedValues;
         fe.rbSelectedValues =this.beforeFillForm.find(m=>m.img===element.img).fields.find(me=>me.folderID===fe.folderID && fe.fieldName===me.fieldName && fe.id===me.id).rbSelectedValues;
         }
         else{
         }
      }
      });
    });
    this.nonSelectedDocJsonList.forEach(ml => {
    this.participantArray.find(m=>m.documentID==ml.documentID).participantJson=JSON.stringify(ml.participantJson);
  });
    this.dialog.closeAll();
  }

  flashFields(){
    this.flash = !this.flash
  }

  close() {
    this.SignButtonEnable=false;
    this.DrawButtonEnable=false;
    this.reasonToDecline="";
    this.declineButtonShow=false;
    this.dialog.closeAll();
  }

  formatSubfolderName(subfolderName){
    if((subfolderName!=null)||(subfolderName!=undefined)){
      let idx = subfolderName.indexOf(" (");
      return subfolderName.substr(0,idx);
    }
  }

  OpentoolDetailText (data: any, id) {
    return;
    var field =  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id);
    if(field.selectedParticipant?.groupRelationParticipantMappingID==0){
      this.assignFilledUnassignedControls(field);
    }
    if(!this.controlAlignArray.find(m=>m.id==id)){
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){        
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign = getData[0].textalign;
        //this.selectedParticipant=getData[0].selectedParticipant;
        this.buttonText = getData[0].buttonName;
        this.buttonURL = getData[0].buttonURL;
        this.acceptOrdeclineText  =getData[0].buttonText
       

        if(this.acceptOrdeclineText=="Approve"){
         this.acceptchecked=true;
         this.declinechecked=false;
        }
        if(this.acceptOrdeclineText=="Decline"){
          this.declinechecked=true;
         this.acceptchecked=false;
         }
         
        if(this.buttonURL !="" && this.buttonURL!=undefined && this.buttonURL !=''){
          const url = this.buttonURL;
          window.open(url, '_blank');
        }
        this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
          if(element.id!=id)
          element.ShowtoolDetail = false;
        });  
      } 
    }
  }

   scrollToPage(pageNo:any) {
    const elementToScroll: HTMLElement=document.getElementById("docHolding"+pageNo);
    document.getElementsByClassName('docSign')[0].scrollTop=elementToScroll.offsetTop-100;
    this.cdr.detectChanges();
  }   

  findFieldValue(field){
    let fieldVal=false;
    //
    if(field.fieldTypeName=="Checkbox" || field.fieldTypeName=='CheckBoxGroup'){
      if(field.chkSelectedValues!=undefined && field.chkSelectedValues.length>0)
         fieldVal=true;
    }
  if(field.fieldTypeName=="radio"){
    if(field.rbSelectedValues!=undefined && field.rbSelectedValues.length>0)
       fieldVal=true;
 
   }  
  if(field.fieldTypeName==="MultiSelect")
  {
    if(field.selectedValue!="" && !Array.isArray(field.selectedValue) && field.selectedValue!=undefined && field.selectedValue.split(',').length>0)
    fieldVal=true;
    else if (field.selectedValue!="" && Array.isArray(field.selectedValue) && field.selectedValue!=undefined && field.selectedValue.length>0)
    {
     fieldVal=true;
    }
  }
  else
  {
    if(field.selectedValue!="" && field.selectedValue!=undefined)
      fieldVal=true;
  }
  //
  return fieldVal;
  } 
  
  checkIfEnabled(field,data):boolean{   
    let fieldVal=false;
    if(this.isPageLoaded && this.IsSigningComplete){
      return false;
    }
    //
    if(field.fieldTypeName=="Checkbox" || field.fieldTypeName=='CheckBoxGroup'){
        if(field.chkSelectedValues!=undefined && field.chkSelectedValues.length>0)
           fieldVal=true;
      }
    if(field.fieldTypeName=="radio"){
      if(field.rbSelectedValues!=undefined && field.rbSelectedValues.length>0)
         fieldVal=true;
   
     }  
    if(field.fieldTypeName==="MultiSelect")
    {
      if(field.selectedValue!="" && !Array.isArray(field.selectedValue) && field.selectedValue!=undefined && field.selectedValue.split(',').length>0)
         fieldVal=true;
         else if (field.selectedValue!="" && Array.isArray(field.selectedValue) && field.selectedValue!=undefined && field.selectedValue.length>0)
         {
          fieldVal=true;
         }
    }
    if(field.fieldTypeName=='File')
    {
      if(field.FileData.length>0)
      {
        fieldVal=true;
      }
    }
    if(field.fieldTypeName=='Image')
    {
      if(field.ImageData.length>0)
      {
        fieldVal=true;
      }
    }
    if(field.fieldTypeName=='Location')
    {
      if(field.Lat!='' && field.Long!='')
      {
        fieldVal=true;
      }
    }
    
    else
    {
      if(field.selectedValue!="" && field.selectedValue!=undefined)
        fieldVal=true;
    }
    
    //
    if(field.selectedParticipant?.groupRelationParticipantMappingID==0){
      if(fieldVal)
      {
        return false;
      }
      return true;
    }
    if(field.selectedParticipant?.groupRelationParticipantMappingID ==undefined){
      if(fieldVal)
      {
        return false;
      }
      return true;
    }else
    {
      let jsoFromArray=this.UnChnagedparticipantJsonListArray.find(n=>n.documentID==this.selectedDocumentId).participantJson;
  
      this.UnChnagedparticipantJsonList=JSON.parse(jsoFromArray);
      if(this.UnChnagedparticipantJsonList.find(x => x.img == data.img)!=undefined)
      {
      
        let unchnagedField=this.UnChnagedparticipantJsonList.find(x => x.img == data.img).fields.find(m=>m.id==field.id);
        if(unchnagedField!=undefined)
        {
        
           if(this.findFieldValue(unchnagedField) && unchnagedField.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId)
            {
              return false;
            }
            return ((!this.IsSigningComplete) && (field.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId));   
         } 
      }
    }    
   }
     
   verifyParticipant(field:any,event:any){
    let fieldVal=false;
    if(!this.IsSigningComplete){
  //
    if(field.fieldTypeName=="Checkbox"){
      if(field.chkSelectedValues!=undefined && field.chkSelectedValues.length>0)
         fieldVal=true;
    }
    if(field.fieldTypeName=="radio"){
      if(field.rbSelectedValues!=undefined && field.rbSelectedValues.length>0)
         fieldVal=true;
   
     }  
    if(field.fieldTypeName==="MultiSelect")
    {
      if(field.selectedValue!="" && !Array.isArray(field.selectedValue) && field.selectedValue!=undefined && field.selectedValue.split(',').length>0)
         fieldVal=true;
         else if (field.selectedValue!="" && Array.isArray(field.selectedValue) && field.selectedValue!=undefined && field.selectedValue.length>0)
         {
          fieldVal=true;
         }
    }
    else
    {
      if(field.selectedValue!="" && field.selectedValue!=undefined)
        fieldVal=true;
    }
  //
      if(field.selectedParticipant!=undefined){
        if((field.selectedParticipant?.groupRelationParticipantMappingID != this.groupRelationParticipantId)
        && (field.selectedParticipant?.groupRelationParticipantMappingID!=0)){
          this.ShowtoolDetail=false;
          field.isControlEnabled = true;
          event.preventDefault();
        }
        else if (field.selectedParticipant?.groupRelationParticipantMappingID==0){
          field.isControlEnabled = false;
        if(field.selectedParticipant?.groupRelationParticipantMappingID ==0){
          if(field.selectedValue==="")
            this.assignFilledUnassignedControls(field);
        }
      }
        else{
          field.isControlEnabled = false;
        }
       }
       else{
        field.isControlEnabled = false;
        if(field.selectedParticipant?.groupRelationParticipantMappingID==0){
          if(!fieldVal)
            this.assignFilledUnassignedControls(field);
        }
      } 
      
      } else {
        this.ShowtoolDetail=false;
        field.isControlEnabled = true;
        event.preventDefault();   
        }     
   }

   assignFilledUnassignedControls(fieldentry){
    if((fieldentry.fieldTypeName=="Number")||(fieldentry.fieldTypeName=="Textarea")||(fieldentry.fieldTypeName=="Textbox")||(fieldentry.fieldTypeName=="Dropdown")){
      if(fieldentry.selectedValue!=""){
        fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
      }  
     }
    else if((fieldentry.fieldTypeName=="CheckBoxGroup")||(fieldentry.fieldTypeName=="Checkbox")){
       if(fieldentry.chkSelectedValues.length>0){
        fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
       }
     }
     else if((fieldentry.fieldTypeName=="Radio")){
       if(fieldentry.rbSelectedValues.length>0){
        fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
       }
     }
   else  if(fieldentry.fieldTypeName=="Location"){
       if((fieldentry.Lat!="") &&(fieldentry.Long!="")){
        fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
       }
     }
     else if(fieldentry.fieldTypeName=="Signature"){
       if(fieldentry.signatureBase64!=""){
        fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
       }
     }
     else if(fieldentry.fieldTypeName=="Initials"){
       if(fieldentry.ImageData!=""){
        fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
       }
     }
     else if(fieldentry.fieldTypeName=="Image"){
       if(fieldentry.ImageData.lenth){
        fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
       }
     }
     else if(fieldentry.fieldTypeName=="File"){
         if(fieldentry.FileData!=""){
          fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
         }
     }
     else if(fieldentry.fieldTypeName=="Draw"){
       if(fieldentry.drawBase64!=""){
        fieldentry["selectedParticipant"] ={groupRelationParticipantMappingID:this.groupRelationParticipantId}
       }
    }
    fieldentry["colorCode"]="215, 245, 255, 1";
   }

   index=[];

   sortArray(a:any){
    let newSortArray= a.sort(function(a, b) {
      //sort by x, secondary by y
        //  if(a.offsetY < b.offsetY && a.offsetX < b.offsetX )
        //  return a.offsetY&& a.offsetX
        //  else if(a.offsetY > b.offsetY && a.offsetX > b.offsetX )
        //  return b.offsetY&& b.offsetX
        //  else if(a.offsetY < b.offsetY  && a.offsetX > b.offsetX  )
        //  return a.offsetY && b.offsetX
        //  else if(a.offsetY > b.offsetY  && a.offsetX < b.offsetX  )
        //  return b.offsetY && a.offsetX
      //return a.offsetX == b.offsetX ? a.offsetY - b.offsetY : a.offsetX - b.offsetX;
     // return a.offsetY == b.offsetY ? a.offsetX- b.offsetX : a.offsetY - b.offsetY;
      return (a.offsetY - b.offsetY);
     });
     return newSortArray;
   }


   movetoNextControl(){
    if(this.index.length==0){
      this.index=[];
      for(var i=0; i< this.particiantJsonList.length;i++){       
        var fields=this.particiantJsonList[i].fields;
        let fieldArray:any=[];
        for(var j=0; j< fields.length;j++){
          if(fields[j].selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId){          
          var ReqModels={
            index:j,
            offsetX:Math.round(fields[j].offsetX),
            offsetY:Math.round(fields[j].offsetY),    
            id:fields[j].id,
            fieldTypeName:fields[j].fieldTypeName,
            pageNo:i
          }
            fieldArray.push(ReqModels);
          }     
        }
        
        if(fieldArray.length>0){
          fieldArray=this.sortArray(fieldArray);
          this.index.push(...fieldArray);
        }
      }
    }
   let currentElement:any="";
   if(this.index.length>0){
    // this.index= this.index.sort(function(a, b){
    //   if (a.x == b.x) return a.y - b.y;
    //       return a.x - b.x || a.y - b.y;
    //   });
    //   this.index = this.index.sort(function(a, b){
    //     if (a.y == b.y) return a.x - b.x;
    //     return a.y - b.y;
    // });

    //   this.index= this.index.sort(function(a, b) {
    //   //sort by x, secondary by y
    //     //  if(a.offsetY < b.offsetY && a.offsetX < b.offsetX )
    //     //  return a.offsetY&& a.offsetX
    //     //  else if(a.offsetY > b.offsetY && a.offsetX > b.offsetX )
    //     //  return b.offsetY&& b.offsetX
    //     //  else if(a.offsetY < b.offsetY  && a.offsetX > b.offsetX  )
    //     //  return a.offsetY && b.offsetX
    //     //  else if(a.offsetY > b.offsetY  && a.offsetX < b.offsetX  )
    //     //  return b.offsetY && a.offsetX
    //   //return a.offsetX == b.offsetX ? a.offsetY - b.offsetY : a.offsetX - b.offsetX;
    //  // return a.offsetY == b.offsetY ? a.offsetX- b.offsetX : a.offsetY - b.offsetY;
    //   return (a.offsetY - b.offsetY);
    //  });

    //this.index = this.index.sort((n1,n2) => n1.offsetY - n2.offsetY);
    //this.index = this.index.sort((n1,n2) => n1.offsetX - n2.offsetX);
    currentElement=this.index[0];
    this.controlIndex=this.index[0].index;
    this.index.splice(0, 1);
   }

    let allfieldsCount = 0;
    this.particiantJsonList.map(function(entry) {
      entry.fields.map(function(fieldentry) {
        fieldentry.ShowtoolDetail =false;
        allfieldsCount++;
        return entry;
      });
    });
    if(this.ControlData==undefined || this.controlIndex>=0){
      if(this.controlIndex>=0|| this.controlIndex==undefined){
        if(this.controlIndex==undefined) this.controlIndex=0;
        if(this.controlIndex >=allfieldsCount){
        this.controlIndex =0;
        this.ControlData =undefined;
        }
        document.getElementById("dh"+currentElement.id).click()
        document.getElementById("docSign").scrollTop = (currentElement.pageNo*1188)+currentElement.offsetY;
        // if(this.ControlData!=undefined && this.controlIndex==0){
        //   let c_ele: HTMLElement = document.querySelectorAll(".iframe-drag-handle[field='"+this.ControlId+"']")[0] as HTMLElement;
        //   this.controlIndex =   parseInt(c_ele?.getAttribute("tabindex")) + 1;
        // }
        // let elements = Array.from(document.getElementsByClassName("iframe-drag-handle"));
        // let element: HTMLElement = document.getElementsByClassName("iframe-drag-handle")[this.controlIndex] as HTMLElement;
        // elements.forEach(ele => {
        //   var tabIndex = ele.getAttribute("tabindex");
        //   if(tabIndex==this.controlIndex.toString()){
        //     element = ele as HTMLElement;
        //     element.dispatchEvent(new Event('click'));
      
        //    // element.focus();
        //     element?.childNodes.forEach(node=>{
            
        //       if(node.nodeType<8){
        //       let child = node as HTMLElement;
        //       if(child.lastElementChild){
        //         var lastelemnt = child.lastElementChild as HTMLElement;
        //       //  lastelemnt.click();
        //       //  lastelemnt.focus();
        //       }
        //       else{
        //        // child.click();
        //        // child.focus();
        //        }
        //       }            
        //     }); 
        //   }
        // });
        if(this.controlIndex<allfieldsCount)
        this.controlIndex++;
        else
        this.controlIndex=0;
      }else{
        var iframeElements =  document.getElementsByClassName("iframe-drag-handle");
        if(this.controlIndex<iframeElements.length)
         this.controlIndex =   this.controlIndex +1;
         else
          this.controlIndex=0;
        
         if(this.controlIndex==undefined) this.controlIndex=0;
         
         let element: HTMLElement = iframeElements[this.controlIndex] as HTMLElement;
        // element?.focus();
        // element?.click();
       
         element?.childNodes.forEach(node=>{
          if(node.nodeType<8){
            let child = node as HTMLElement;
            if(child.lastElementChild){
              var lastelemnt = child.lastElementChild as HTMLElement;
             // lastelemnt.focus();
            }
            else{
            //  child.focus();
             }
            }          
         });
      }
    }
    else{
      if (this.particiantJsonList.find(x => x.img == this.ControlData.img) && this.particiantJsonList.find(x => x.img == this.ControlData.img).fields.length > 0) {
       var iframeElements =  document.getElementsByClassName("iframe-drag-handle");
        let ele: HTMLElement = document.querySelectorAll(".iframe-drag-handle[field='"+this.ControlId+"']")[0] as HTMLElement;

       if(this.controlIndex<allfieldsCount)
         this.controlIndex =   this.controlIndex +1;
         else
          this.controlIndex=0;
        
         if(this.controlIndex==undefined) this.controlIndex=0;
         
         let element: HTMLElement = iframeElements[this.controlIndex] as HTMLElement;
         //element?.focus();
        // element?.click();
       
         element?.childNodes.forEach(node=>{
          if(node.nodeType<8){
            let child = node as HTMLElement;
            if(child.lastElementChild){
              var lastelemnt = child.lastElementChild as HTMLElement;
            //  lastelemnt.focus();
            }
            else{
            //  child.focus();
            }
            }          
          });        
        }
      }
   }



   setTabIndex(pageIndex,controlIndex){
     if(pageIndex>0){
       return this.particiantJsonList[pageIndex-1]?.fields?.length+controlIndex;
     }
     else{
       return controlIndex;
     }
   }

   

  setPagePageStyle(index){
    return index<this.particiantJsonList.length-1;
  }

  OpentoolDetail(message: any) {
    return;
    this.ShowtoolDetail = false;
    this.showToolsLeft = false;
    this.Sdropdown = false;
    this.Smuldropdown=false;
    this.Sbutton = false;
    this.Snumber = false;
    this.Sradio = false;
    this.Scheckbox = false;
    this.Scheckboxgroup=false;
    this.Stable = false;
    this.Sbullet = false;
    this.Sformat = false;
    this.Sdraw = false;
    this.Stext = false;
    this.SButtontext=false;
    this.SURL= false;
    this.Smeasure = false;
    this.Sline = false;
    this.Smultiline = false;
    this.Ssingleline = false;
    this.Sthrough=false;
    this.SwhiteOut=false;
    this.ShighLight=false;
    this.Ssignature = false;
    this.Sinitials = false;
    this.Sapproval = false;
    this.Sdate = false;
    this.Stime = false;
    this.Slocation = false;

    this.SbuttonLabel = false;
    this.Simage = false;
    this.Sfile = false;
    this.SURLL=false;

    if (message == 'Signature') {
      this.Ssignature = true;
    }

    if (message == 'Initials') {
      this.Sinitials = true;
    }

    if (message == 'File') {
      this.Sfile = true;
    }

    if (message == 'Image') {
      this.Simage = true;
    }

    if (message == 'Location') {
      this.Slocation = true;
      this.Sformat = true;
    }

    if (message == 'Time') {
      this.Stime = true;
      this.Sformat = true;
    }

    if (message == 'Date') {
      this.Sdate = true;
      this.Sformat = true;
    }

    if (message == 'ApproveOrDecline') {
      this.Sapproval = true;
      this.SreadOnly = false;
     // this.Srequired = true;
      this.Sbutton = true;
      this.Sformat = true;
    }

    if (message == 'Textbox') {
      this.Ssingleline = true;
      this.Stext = true;
      this.Sformat = true;     
    }

    if (message == 'BulletList') {
      this.Sformat = true;
      this.Sbullet = true;
    }

    if (message == 'Textarea') {
      this.Smultiline = true;
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'Date') {
      this.Sformat = true;
    }

    if (message == 'line' || message=='StraightLine') {
      this.Sline = true;
    }

    if (message == 'measure') {
      this.Smeasure = true;
    }

    if (message == 'Draw') {
      this.Sdraw = true;
    }
    

    if (message == 'format') {
      this.Sformat = true;
    }

    if (message == 'Table') {
      this.Stable = true;
      this.Stext = false;
    }

    if (message == 'text') {
      this.Stext = true;
      this.Sformat = true;
    }

    if (message == 'Radio') {
      this.Sradio = true;
      this.Sformat = true;
    }

    if (message == 'Checkbox') {
      this.Scheckbox = true;
      this.Sformat = true;
    }

    if (message == 'CheckBoxGroup') {
      this.Scheckboxgroup = true;
      this.Sformat = true;
    }

    if (message == 'MultiSelect') {     
       this.Smuldropdown=true;
       this.Sformat = true;
    }

    if (message == 'Dropdown') {
      this.Sdropdown = true;
      this.Sformat = true;
    }

    if (message == 'Button') {
      this.SbuttonLabel = true;     
      this.SButtontext=true;
      this.SURL=true;     
      this.Sformat = true;
    }

    if (message == 'Number') {
      this.Snumber = true;
      this.Sformat = true;
    }
    if(message=='StrikeThrough'){
      this.Sthrough=true;
    }
    if(message=="WhiteOut"){
      this.SwhiteOut=true;
    }

    if(message=="HighLight"){
      this.ShighLight=true;
    }
    if(message=="URL"){
      this.SURLL=true;
      this.Sformat = true;
    }    
   
  }
 
  
   highlightRequiredControls(){
    this.showAllRequiredControls=!this.showAllRequiredControls;
    this.particiantJsonList.map((entry) =>{
      entry.fields.map((fieldentry)=> {
        if(this.showAllRequiredControls){
        if((fieldentry.isRequired==true)&&(fieldentry.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId)){
          fieldentry.showRequiredControls = true;
        }        
      }
      else{
        fieldentry.showRequiredControls = false;     
       }
        return entry;
      });
    });
   }


   CheckIfRequiredFieldsAreFilled(){
     let AllFieldsAreFilled=true;
     let Counter =0;
     this.particiantJsonList.map((entry) =>{
       var t = entry.fields.filter(fieldentry=>((fieldentry.isRequired==true)&&(fieldentry.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId)))
       t.map((fieldentry)=> {      
        if((fieldentry.isRequired==true)&&(fieldentry.selectedParticipant?.groupRelationParticipantMappingID == this.groupRelationParticipantId)){
      
          if((fieldentry.fieldTypeName=="Number")||(fieldentry.fieldTypeName=="Textarea")||(fieldentry.fieldTypeName=="Textbox")||(fieldentry.fieldTypeName=="Dropdown")){
           if(fieldentry.selectedValue==""){
            fieldentry.showRequiredControls = true;
            Counter++;
           }  
          }
         else if((fieldentry.fieldTypeName=="CheckBoxGroup")||(fieldentry.fieldTypeName=="Checkbox")){
            if(fieldentry.chkSelectedValues.length==0){
              fieldentry.showRequiredControls = true;
              Counter++;
            }
          }
          else if((fieldentry.fieldTypeName=="Radio")){
            if(fieldentry.rbSelectedValues.length==0){
              fieldentry.showRequiredControls = true;
              Counter++;
            }
          }
        else  if(fieldentry.fieldTypeName=="Location"){
            if((fieldentry.Lat=="") &&(fieldentry.Long=="")){
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
          else if(fieldentry.fieldTypeName=="Signature"){
            if((fieldentry.signatureBase64=='' || fieldentry.signatureBase64==undefined) && (fieldentry.signatureText=='' || fieldentry.signatureText==undefined) && (fieldentry.ImageData.length==0)  )
            {
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
          else if(fieldentry.fieldTypeName=="Initials"){
            if((fieldentry.signatureBase64=='' || fieldentry.signatureBase64==undefined) && (fieldentry.signatureText=='' || fieldentry.signatureText==undefined) && (fieldentry.ImageData.length==0)  )
            {  
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
          else if(fieldentry.fieldTypeName=="Image"){
            if(fieldentry.ImageData==""){
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
          else if(fieldentry.fieldTypeName=="File"){
              if(fieldentry.FileData==""){
                fieldentry.showRequiredControls=true;
                Counter++;
              }
          }
          else if(fieldentry.fieldTypeName=="Draw"){
            if(fieldentry.drawBase64==""){
              fieldentry.showRequiredControls=true;
              Counter++;
            }
          }
        }        

      else{
        fieldentry.showRequiredControls = false; 
      }
    });
    });
      if(Counter>0){
        this.toastr.warning("All Required fields are not filled.");
        this.spinner=false;
        return false;
      }
      else{
        return true;
      }
   }

  specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];
  regex: RegExp = new RegExp(/^\d*\.?\d{0,10}$/g);

  numberOnly(event): boolean {
    let value = event.target.value;
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
     let current: string = value;
      const position = event.target.selectionStart;
      const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
      if (next && !String(next).match(this.regex)) {
       event.preventDefault();
      }   
  }

  //  numberOnly(event): boolean {
  //   const charCode = event.which ? event.which : event.keyCode;
  //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  //     return false;
  //   }
  //   return true;
  // }

  addActiveClass(item:any){
    this.particiantJsonList.map(function(entry) {
          entry.fields.map(function(fieldentry) {
            fieldentry.ShowtoolDetail =false;
            return entry;
        });
      });
    return item.ShowtoolDetail = true;
  }

  OpentoolDetailMulDropDown (data: any, id) {
    return;
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){       
        if(getData[0].fieldID > 0 ){
         this.dropdownddisabled =true;      
        }else{
          this.dropdownddisabled =false;
        }
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily; 
        this.textalign= getData[0].textalign;
      }   
    }
  }

  onSelectImage(event,data: any,id) {
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++){
      var ext = filename[i].name.split('.').pop();
      ext=ext.toLowerCase();
      if (ext != 'png' && ext != 'jpg' && ext != 'jpeg'&& ext != 'gif'&& ext != 'bmp' && ext != 'tiff') {
        alert('only image upload');
        return;
      }
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
  
        var base64String = reader.result;        
        
        var ImageObj =[];
        ImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath:filename[i],
          Imageurl:base64String
        });     
       if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
       let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
       this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).ImageData = ImageObj  
       if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID==0)  
         {
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
         }      
       this.particiantJsonList = this.particiantJsonList;
     }
   }  
 
  }    
  }

  ifChkChecked(id,data,childCtrlId) {   
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
    return  selectedValue.includes(childCtrlId);
    }
  return false;
  }

  ifChkCheckedAutoFill(field,data,childCtrlId) {
    let id=field.id;

    let coretFolder:any=[];
    coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));	
	
	 let contactFolder:any= [];
    contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
	
	let comFolder:any=[];
    comFolder.push(this.fieldFolders.find(n=>n.name=='Company'));

    if (contactFolder[0].folderID==field.folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue= this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
    return  selectedValue.includes(childCtrlId);
    }
    else if (coretFolder[0].folderID==field.folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue= this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
    return  selectedValue.includes(childCtrlId);
    }
    else if (comFolder[0].folderID==field.folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue= this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues;
    return  selectedValue.includes(childCtrlId);
    }
  return false;
  }

  ifRadioChecked(id,data,childCtrlId) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      let selectedValue= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues;
    return  selectedValue.includes(childCtrlId);
    }
  return false;
  }

  OnChangeCheckBoxGroup($event: any, chk: any, id: any, data: any,childCtrlID:any) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      if ($event.target.checked) {
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.push(childCtrlID);
        this.particiantJsonList = this.particiantJsonList;
      } else {
        if(
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.find((s) => s == childCtrlID)
        ) {
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues =
            this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).chkSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
    if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID==0)
     {
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
     }
  }

  
  onChange(value: any, data: any, field) {   
    let selectedCtrlFolderID= field.folderID;
    field.selectedValue=value;
   let fieldParticipantID= field.selectedParticipant?.groupRelationParticipantMappingID;
   fieldParticipantID=(fieldParticipantID==undefined ?0:fieldParticipantID);
	 let contactFolder:any= []//folderAccess.find(b=>b.folderName=='Contact');
   contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img)) {
      if(this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
        this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
     
      this.participantArray.forEach(ml => {
      if(this.selectedDocumentId!==ml.documentID){
        let jsonelement= JSON.parse(ml.participantJson);
        jsonelement.forEach(element => {
          element.fields.forEach(fe => {
           if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
           {
             fe.selectedValue=field.selectedValue;
           }
          });
        });
        ml.participantJson=JSON.stringify(jsonelement);
      }
      else
      {
     this.particiantJsonList.forEach(element => {
       element.fields.forEach(fe => {
        if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
        {
          fe.selectedValue=field.selectedValue;
        }
       });
     });
    }
    });
      this.text=value;
    }

    let coretFolder:any=[]; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img)) {
      if(this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
        this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
     
       this.participantArray.forEach(ml => {
       if(this.selectedDocumentId!==ml.documentID){
        let jsonelement= JSON.parse(ml.participantJson);
        jsonelement.forEach(element => {
          element.fields.forEach(fe => {
           if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
           {
             fe.selectedValue=field.selectedValue;
           }
          });
        });
        ml.participantJson=JSON.stringify(jsonelement);
      }
      else
      {
     this.particiantJsonList.forEach(element => {
       element.fields.forEach(fe => {
        if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
        {
          fe.selectedValue=field.selectedValue;
        }
       });
     });
    }
    });
      this.text=value;
    }

    
	let comFolder:any=[];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
  comFolder.push(this.fieldFolders.find(n=>n.name=='Company'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img)) {
      if(this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
      this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
     
      this.participantArray.forEach(ml => {
      if(this.selectedDocumentId!==ml.documentID){
        let jsonelement= JSON.parse(ml.participantJson);
        jsonelement.forEach(element => {
          element.fields.forEach(fe => {
           if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
           {
             fe.selectedValue=field.selectedValue;
           }
          });
        });
        ml.participantJson=JSON.stringify(jsonelement);
      }
      else
      {
     this.particiantJsonList.forEach(element => {
       element.fields.forEach(fe => {
        if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
        {
          fe.selectedValue=field.selectedValue;
        }
       });
     });
    }
    });
      this.text=value;
    }

    if (fieldParticipantID==this.groupRelationParticipantId && ((selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
    || (selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
     || (selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0)
     ))
   {
     if(this.particiantJsonList.find(x => x.img == data.img)!==undefined)
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;

   }
   else if(this.particiantJsonList.find(x => x.img == data.img)!==undefined && this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID==0)
     {
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
     }
     else if(this.particiantJsonList.find(x => x.img == data.img)!==undefined && this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID>0)
     {
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
     }
  }
   

  onChangeTexarea(value: any, data: any, field) {
    var widthTest = document.getElementById(field.id);   
    var height = (widthTest.clientHeight + 25);  
    let selectedCtrlFolderID= field.folderID;
        field.selectedValue=value;
     let fieldParticipantID= field.selectedParticipant?.groupRelationParticipantMappingID;
     fieldParticipantID=(fieldParticipantID==undefined ?0:fieldParticipantID);
    let contactFolder:any= []//folderAccess.find(b=>b.folderName=='Contact');
    contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
     if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img)) {
       
      if(this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
      {
      this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
      this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
      }
     
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID){
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
               fe.selectedValue=field.selectedValue;
             }
            });
          });
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
        {
       this.particiantJsonList.forEach(element => {
         element.fields.forEach(fe => {
          if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
          {
            fe.selectedValue=field.selectedValue;
          }
         });
       });
      }
      });
       this.text=value;
     }
 
     let coretFolder:any=[]; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
     coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));
     if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img)) {
      if(this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
      {
      this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
      this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
      } 
     
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID){
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
               fe.selectedValue=field.selectedValue;
             }
            });
          });
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
        {
       this.particiantJsonList.forEach(element => {
         element.fields.forEach(fe => {
          if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
          {
            fe.selectedValue=field.selectedValue;
          }
         });
       });
      }
      });
       this.text=value;
     }
 
     
   let comFolder:any=[];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
   comFolder.push(this.fieldFolders.find(n=>n.name=='Company'));
     if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img)) {
      if(this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined)
      {
      this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
      this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
      }  
     
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID){
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
               fe.selectedValue=field.selectedValue;
             }
            });
          });
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
        {
       this.particiantJsonList.forEach(element => {
         element.fields.forEach(fe => {
          if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
          {
            fe.selectedValue=field.selectedValue;
          }
         });
       });
      }
      });
       this.text=value;
     }
 
     if (fieldParticipantID==this.groupRelationParticipantId && ((selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
     || (selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
      || (selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0)
      ))
    { 
      if(this.particiantJsonList.find(x => x.img == data.img)!==undefined)
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
    }
    else if(this.particiantJsonList.find(x => x.img == data.img)!==undefined && this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID==0)
      {
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;       
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
      }
      else if(this.particiantJsonList.find(x => x.img == data.img)!==undefined && this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID>0)
      {
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedValue = value == undefined ? '' : value;
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).offsetHeight = height == undefined ? '' : height;
      }
  }

  SignButtonEnable:boolean=false;
  DrawButtonEnable:boolean=false;
  InitailButtonEnable:boolean=false;
  
  drawComplete() {
    this.SignButtonEnable=true;
    this.DrawButtonEnable=true;
    this.InitailButtonEnable=true;
    // will be notified of szimek/signature_pad's onEnd event    
  }
 
  drawStart() {
    // will be notified of szimek/signature_pad's onBegin event   
  }

  onStart(event) {    
   }
 
   onStop(event) {    
   }
 
   onMoving(event, i) {
     this.movingOffset.x = event.x;
     this.movingOffset.y = event.y;
   }
  
   hexToRGBA(hex, opacity) {
    if(hex==undefined){
      return;
    }
    return  (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length/3 + '})', 'g')).map(function(l) { return parseInt(hex.length%2 ? l+l : l, 16) }).concat(isFinite(opacity) ? opacity : 1).join(',') ;
  }
     
  imgDrawStart(){   
     if(this.brushColor!="")
     this.signaturePadOptions.penColor = "RGB("+this.hexToRGBA(this.brushColor,1)+")";
     else{
       this.brushColor=this.penColor;
     this.signaturePadOptions.penColor = "RGB("+this.hexToRGBA(this.brushColor,1)+")"; 
     } 
   }

   ngAfterViewInit() {
    if(this.signaturePad!=undefined) {
    this.signaturePad.set('minWidth', 2); // set szimek/signature_pad options at runtime
    this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }
  }

  clearSignature(){
    this.SignButtonEnable=false;
    if(this.signaturePad!=undefined) {
    this.signaturePad.clear();
    }
    let canvas = document.getElementsByTagName("canvas")[0]; 
    if(canvas!=undefined) {
       var  context = canvas.getContext('2d');
      context.clearRect(0,0,canvas.width,canvas.height);
      context.beginPath();
     }
  }

   currentSign= {
    data:'',
    id:''
  }


  SaveSign(data) {
    this.signatureImage = data;
  }  

  OpentoolDetailBulletList (data: any, id) {
    return;
    if(!this.controlAlignArray.find(m=>m.id==id)) {
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        if(getData[0].fieldTypeName == "BulletList" ){
          this.bulletFieldArray= getData[0].fillList;          
        }        
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign= getData[0].textalign;  
      }
    }
   }

    dialogueRef:any;
    filenameForSign = "";
    penColor:string="";

   OpenSignPopup(templateRef: TemplateRef<any>,data:any,item:any) {   
     if(this.checkIfEnabled(item,data)) {
    this.ControlData=data;
    this.ControlId=item.id;
    this.SignButtonEnable=false;
    this.InitailButtonEnable=false;
    if(this.ControlId==undefined){
      this.ControlId=item;
    }
    this.Ssignature=true;
    this.currentSign.data=data;
    this.currentSign.id=item.id;
    this.filenameForSign = "";
    this.signName="";
    this.selected=''
    this.signOpt = 'draw';   
    this.dialogueRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalboxSign'
    });
  
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
        if(element.id!=item.id)
        element.ShowtoolDetail = false;
        else
        element.ShowtoolDetail = true;
      });
     
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  item.id);
      if(getData.length > 0){
        this.ControlData = FieldsDetails;
        this.ControlId = item.id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;     
        if(getData[0].brushColor!=undefined)
        this.brushColor = getData[0].brushColor;   
      } 
      var penColor=""; 
      if(item.penColor=="" || item.penColor==undefined){
        this.penColor="#000000f2";
      }else{
        this.penColor=item.penColor;
      }
      var sigContainer=document.querySelector(".allSCont") as HTMLElement;
      this.signaturePadOptions={
      'minWidth': 2,
      'canvasWidth': sigContainer.clientWidth,
      'canvasHeight': sigContainer.clientHeight,
      'penColor':this.penColor,//"#000000f2"
     }
      //this.imgDrawStart();
     }
    }
  }

  drawnImg= {
    data:'', 
    id:''
  }

  OpenDrawPopup(templateRef: TemplateRef<any>,data:any,field:any,id:any) {
  if(this.checkIfEnabled(field,data)) {
    this.drawnImg.data=data;
    this.drawnImg.id=id;
    this.DrawButtonEnable=false;
    this.dialogueRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
 
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      this.particiantJsonList.find(x => x.img == data.img).fields.forEach(element => {
        if(element.id!=id)
        element.ShowtoolDetail = false;
      });
      field.ShowtoolDetail =true;
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;     
        if(getData[0].brushColor!=undefined)
        this.brushColor = getData[0].brushColor;  
      }  
      if(field.penColor=="" || field.penColor==undefined){
        this.penColor="#000000f2";
      }else{
        this.penColor=field.penColor;
      }   
      var sigContainer=document.querySelector(".allSCont") as HTMLElement;
      this.signaturePadOptions={
        'minWidth': 3,
        'canvasWidth': sigContainer.clientWidth,
        'canvasHeight': sigContainer.clientHeight,
        'penColor':this.penColor//"#000000f2"
      }
      //this.imgDrawStart();
     }
    }
  }

  signOrInitialTextChanges(e:any) {
    if(this.signName!=='' && this.signName!==undefined) {
      this.SignButtonEnable=true;
      this.InitailButtonEnable=true;
      this.signatureBase64=''; 
      this.signOrInitialImageObj=[];  
   }else{
     this.SignButtonEnable=false;
     this.InitailButtonEnable=false;
   }
  }

  radioChangeSign(){
    this.SignButtonEnable=false;
  }

  radioChangeInitails(){
    this.InitailButtonEnable=false;
  }

  setSignInitialFontFamilyChange(e:any) {
    this.signInitialFontFamily=e;
  }

  OpentoolDetailRadioButtonGroup (data: any, id,fillListcontrolId: any) {
    return;
    if(!this.controlAlignArray.find(m=>m.id==id)){
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        if(getData[0].fieldTypeName == "Radio" ){
          this.radioButtonGroupFieldArray= getData[0].fillList;          
        }       
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.fillListcontrolId=fillListcontrolId;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign= getData[0].textalign;     
      }    
    }
   }
   
  fillListcontrolId:any;
  
  OpentoolDetailCheckBoxGroup (data: any, id,fillListcontrolId: any) {
    return;
    if(!this.controlAlignArray.find(m=>m.id==id)) {
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        if(getData[0].fieldTypeName == "CheckBoxGroup"){         
          this.checkboxGroupFieldArray = getData[0].fillList;       
        }
        if(getData[0].fieldID > 0){
         this.checkboxdisabled =true;      
        }else{
          this.checkboxdisabled =false;
        }
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.fillListcontrolId=fillListcontrolId;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign= getData[0].textalign;   
      }
    }
   }

   onSelectSignImage(event,data: any,id:any) {
    data=this.currentSign.data;
    id=this.currentSign.id;
    var filename = event.target.files;
    for (let i = 0; i < filename.length; i++){
      var ext = filename[i].name.split('.').pop();
      if (ext.toUpperCase() != 'png'.toUpperCase() && ext.toUpperCase() != 'jpg'.toUpperCase() && ext.toUpperCase() != 'jpeg'.toUpperCase()) {
        alert('only image upload');
        return;
      }
      this.SignButtonEnable=true;
      this.InitailButtonEnable=true;
      const file = event.target.files[i];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        this.Imageurl = event.target.result;
        var FullPath = filename[i].name;
        var documentNameSplit = FullPath.split('.');
        var documentName = documentNameSplit[0];
        var documenttype = documentNameSplit[1];
        this.filenameForSign = documentName;
        var base64String = reader.result;        
        
         this.signOrInitialImageObj =[];
         this.signOrInitialImageObj.push({
          FileName: documentName,
          FileExtention: documenttype,
          FilePath:filename[i],
          Imageurl:base64String
        });  
        this.signatureBase64=''; 
        this.signName='';   
        if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
          let fillList= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).fillList;
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).signatureBase64 = '';      
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).signatureText = ''; 
          this.particiantJsonList = this.particiantJsonList;
        }
     }  
    } 
  }

  checkboxdisabled:boolean =false;
  OpentoolDetailCheckBox (data: any, id,fillListcontrolId: any) {
    return;
    if(!this.controlAlignArray.find(m=>m.id==id)) {
    this.controlAlignArray.push({
      fieldTypeName:this.particiantJsonList.find(x => x.img == data.img).fields.find(n=>n.id==id).fieldTypeName,
      img:data.img,
      id:id
    });
  }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      var FieldsDetails = (this.particiantJsonList.find(x => x.img == data.img))
      var getData = FieldsDetails.fields.filter(x => x.id ===  id);
      if(getData.length > 0){
        if(getData[0].fieldTypeName == "Checkbox" ){
          this.checkboxFieldArray= getData[0].fillList;          
        }
        if(getData[0].fieldID > 0 ){
         this.checkboxdisabled =true;      
        }else{
          this.checkboxdisabled =false;
        }
        this.text = getData[0].selectedValue;
        this.ControlData = FieldsDetails;
        this.ControlId = id;
        this.fillListcontrolId=fillListcontrolId;
        this.isRequired = getData[0].isRequired;
        this.readonly = getData[0].readonly;
        this.characterlimit = getData[0].charLimit;
        this.textColor = getData[0].fontColor;
        var size = getData[0].fontSize.substr(0, getData[0].fontSize.length-2);
        this.fontsize = Number(size);
        this.fontstyle = getData[0].fontstyle;
        this.fontweight = getData[0].fontweight;
        this.textdecoration = getData[0].textdecoration;
        this.fontfamily = getData[0].fontfamily;
        this.textalign= getData[0].textalign; 
      }     
    }
   }

   OnChangeRadio($event: any, rb: any, id: any, data: any,childCtrlID:any) {
    if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID==0)
    {
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
    }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      if ($event.target.checked) {       
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues=[];
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.push(childCtrlID);
        this.particiantJsonList = this.particiantJsonList;
      } else {
       if(       
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.find((s) => s == childCtrlID)
        ) {
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues =
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).rbSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
  }

   OnChangeCheckBox($event: any, chk: any, field: any, data: any,childCtrlID:any) {
    let selectedCtrlFolderID= field.folderID;
    let fieldParticipantID= field.selectedParticipant?.groupRelationParticipantMappingID;
    fieldParticipantID=(fieldParticipantID==undefined ?0:fieldParticipantID);

	  let contactFolder:any= []//folderAccess.find(b=>b.folderName=='Contact');
    contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img)) {
      if (
        this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined
      )
      {
      if ($event.target.checked) {       
        this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);      
        this.particiantJsonListAutoFill = this.particiantJsonListAutoFill;
      } else {
        if (
          this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.find((s) => s == childCtrlID)
        ) {
          this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
          this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }

      //
     // let field =  this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == field.id);
     
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID)
        {
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
              if ($event.target.checked) {       
                fe.chkSelectedValues.push(childCtrlID);      
              } else {
                
                fe.chkSelectedValues =
                fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                
              }
             }
            });
          }); 
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
      {
      this.particiantJsonList.forEach(element => {
        element.fields.forEach(fe => {
         if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
         {
          if ($event.target.checked) {       
            fe.chkSelectedValues.push(childCtrlID);      
          } else {
            
            fe.chkSelectedValues =
            fe.chkSelectedValues.filter((s) => s !== childCtrlID)
            
          }
         }
        });
      });
    }
  });
      //
    }
    let coretFolder:any=[]; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
    coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img)) {
      if (
        this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined
      )
      {
      if ($event.target.checked) {       
        this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);  
      } else {
        if (
          this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.find((s) => s == childCtrlID)
        ) {
          this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
          this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
      //
    //  let field =  this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == field.id);
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID)
        {
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
              if ($event.target.checked) {       
                fe.chkSelectedValues.push(childCtrlID);      
              } else {
                
                fe.chkSelectedValues =
                fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                
              }
             }
            });
          }); 
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
      {
      this.particiantJsonList.forEach(element => {
        element.fields.forEach(fe => {
         if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
         {
          if ($event.target.checked) {       
            fe.chkSelectedValues.push(childCtrlID);      
          } else {
            
            fe.chkSelectedValues =
            fe.chkSelectedValues.filter((s) => s !== childCtrlID)
            
          }
         }
        });
      });
    }
  });
      //
    }

    let comFolder:any=[];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
    comFolder.push(this.fieldFolders.find(n=>n.name=='Company'));
    if (fieldParticipantID==this.groupRelationParticipantId && selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img)) {
      if (
        this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id)!==undefined
      )
      {
      if ($event.target.checked) {       
        this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID); 
      } else {
        if (
          this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.find((s) => s == childCtrlID)
        ) {
          this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
          this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
        }
      }
    }
      //
      //let field =  this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == field.id);
      this.participantArray.forEach(ml => {
        if(this.selectedDocumentId!==ml.documentID)
        {
          let jsonelement= JSON.parse(ml.participantJson);
          jsonelement.forEach(element => {
            element.fields.forEach(fe => {
             if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
             {
              if ($event.target.checked) {       
                fe.chkSelectedValues.push(childCtrlID);      
              } else {
                
                fe.chkSelectedValues =
                fe.chkSelectedValues.filter((s) => s !== childCtrlID)
                
              }
             }
            });
          }); 
          ml.participantJson=JSON.stringify(jsonelement);
        }
        else
      {
      this.particiantJsonList.forEach(element => {
        element.fields.forEach(fe => {
         if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
         {
          if ($event.target.checked) {       
            fe.chkSelectedValues.push(childCtrlID);      
          } else {
            
            fe.chkSelectedValues =
            fe.chkSelectedValues.filter((s) => s !== childCtrlID)
            
          }
         }
        });
      });
    }
  });
      //
    }

    if (fieldParticipantID==this.groupRelationParticipantId && ((selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
    || (selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
     || (selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0)))
   {
    if(this.particiantJsonList.find(x => x.img == data.img)!==undefined && $event.target.checked)
     this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;

   }
   else if(this.particiantJsonList.find(x => x.img == data.img)!==undefined &&this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID==0)
     {
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
         if ($event.target.checked) {       
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);      
        } else {
          
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
          this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
          
        }
    }
    else if(this.particiantJsonList.find(x => x.img == data.img)!==undefined && this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).selectedParticipant?.groupRelationParticipantMappingID>0)
    {
        if ($event.target.checked) {       
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.push(childCtrlID);      
       } else {
         
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues =
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == field.id).chkSelectedValues.filter((s) => s !== childCtrlID)
         
       }
   }

  }

  drawImgBase64:string;

  addDrawnImg() {
    let data:any=this.drawnImg.data;
    if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).selectedParticipant?.groupRelationParticipantMappingID==0)
    {
        this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
    }
    let canvas = document.getElementsByTagName("canvas")[0]; 
    if(canvas!=undefined)
     this.drawImgBase64=canvas.toDataURL();
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).drawBase64 = this.drawImgBase64;      
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id).brushColor = this.brushColor;
      var field =  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.drawnImg.id);
      if(field.selectedParticipant?.groupRelationParticipantMappingID==0){
        this.assignFilledUnassignedControls(field);
      }
      this.particiantJsonList = this.particiantJsonList;
    }
    this.dialogueRef.close();
  }


  addSignature() {
    let data:any=this.ControlData;
    let canvas = document.getElementsByTagName("canvas")[0]; 
    if(canvas!=undefined){
     this.signatureBase64=canvas.toDataURL();
     this.signName="";
     this.signOrInitialImageObj=[];
    }
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).participantEmailId = this.participantEmailId;
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureBase64 = this.signatureBase64;      
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signatureText = this.signName;
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).signInitialFontFamily = this.signInitialFontFamily;
      this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).ImageData = this.signOrInitialImageObj;
      var field =  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId);
      
      if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant?.groupRelationParticipantMappingID==0)
     {
         this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == this.ControlId).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
     }
      
      this.particiantJsonList = this.particiantJsonList;
   }
   this.dialogueRef.close();
  }
   
  saveBtn($event){
    //saveAs($event,'image.jpg');
  }

  OpenDrawInPopup(templateRef: TemplateRef<any>) {   
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });   
  }

  onDragEnd(event: DragEvent) {
    
  }

  clickinText:boolean=false;
  clickinInitials:boolean=false;
  clickinSignature:boolean=false;
  offsetWidth:number=0;
  offsetHeight:number=0;
  waitPointer:boolean=false;

  clickTextField(msg){
    this.clickinText = true;
    this.clickinInitials=false;
    this.clickinSignature=false;
    this.waitPointer=true;
  }

  clickInitialsField(msg){
    this.clickinInitials=true;
    this.clickinText = false;
    this.clickinSignature=false;
    this.waitPointer=true;
  }

  clickSignatureField(msg){
    this.clickinSignature=true;
    this.clickinInitials=false;
    this.clickinText = false;
    this.waitPointer=true;
  }


  convertRBA2RGB(colourCode){
    let colorcodes = [];
    if(colourCode=="" || colourCode==undefined || colourCode==null){
       colourCode = "215, 245, 255, 1";
    }
   if(colourCode!="" || colourCode!=undefined || colourCode!=null){
     colorcodes = colourCode.split(',');
     colorcodes.pop();
     return colorcodes.join(',');
   }  
   else{
     return colourCode;
   }
  }

  onClickonImage(event:any,list: any){  
    if(this.clickinText==true) {     
      var name = "Textbox" + '-' + new Date().getTime();

      var textaligns:string="left";   
      this.offsetWidth=150;
      this.offsetHeight=30;
      var colorCode:string="";
      var colorCodeAlpha:string="";
      var selectedParticipant :string="";
      if(this.particiantJsonList.length > 0) {
        var color = this.particiantJsonList[0].fields;
         if(color.length > 0){
          colorCode = color[0].colorCode;
          colorCodeAlpha = color[0].colorCodeAlpha;
          //selectedParticipant = color[0].selectedParticipant;
       }  
      }
      
    
     let fieldJson = {
      "id": name,
      "isControlEnabled": false,
      "fieldID": 0,
      "fieldName": "Single-Line",
      "folderID": 0,
      "folderName": "",
      "fieldTypeID": 0,
      "fieldTypeName": "Textbox",
      "Control":"Static",
      "placeholder": "",
      "defaultValue": "",
      "fillList": [],
      "FileData":[],
      "ImageData":[],
      "rows":"",
      "column":"",
      "selectedValue": '',
      "isRequired": false,
      "isEditable": false,
      "readonly": false,
      "charLimit": "40",
      "fontSize": "14px",
      "fontName": "",
      "fontstyle":"",
      "fontweight":"",
      "textdecoration":"",
      "fontColor": "",
      "fontfamily":"Roboto",
      "offsetX": event.offsetX,
      "offsetY": event.offsetY,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign":textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": "",
      "fieldNames": "",
      "buttonText":"",
      "signatureBase64":"",
      "signatureText":'',
      "drawBase64":"",
      "colorCode":colorCode,
      "colorCodeAlpha":colorCodeAlpha,
      'signInitialFontFamily':'',
      'Lat' :'',
      'Long' :'',
      "selectedParticipant":selectedParticipant,
      "backgroundColor":"",
      "buttonName":"Button",
      "buttonURL":"",
      "brushColor":"",
      "rotation":0,
      "ShowtoolDetail":false,
      "offsetWidth":this.offsetWidth,
      "offsetHeight":this.offsetHeight,
      "showRequiredControls":false,
      "filledData":false,
      "isDisabled":false,
    }

    if (this.particiantJsonList.find(x => x.img == list.img)) {
      this.particiantJsonList.find(x => x.img == list.img).fields.push(fieldJson);
      this.particiantJsonList = this.particiantJsonList;
     }
    }

    if(this.clickinInitials==true) {
    
      var name = "Initials" + '-' + new Date().getTime();

      var textaligns:string="center";   
     // this.offsetWidth=140;
     // this.offsetHeight=70;

      this.offsetWidth=79;
      this.offsetHeight=52;
      
      if(this.particiantJsonList.length > 0) {
        var color = this.particiantJsonList[0].fields;
         if(color.length > 0){
          colorCode = color[0].colorCode;
          colorCodeAlpha = color[0].colorCodeAlpha;
          //selectedParticipant = color[0].selectedParticipant;
       }  
      }

     let fieldJson = {
      "id": name,
      "fieldID": 0,
      "fieldName": "Initials",
      "folderID": 0,
      "folderName": "",
      "fieldTypeID": 0,
      "fieldTypeName": "Initials",
      "Control":"Static",
      "placeholder": "",
      "defaultValue": "",
      "fillList": [],
      "FileData":[],
      "ImageData":[],
      "rows":"",
      "column":"",
      "selectedValue": '',
      "isRequired": false,
      "readonly": false,
      "charLimit": "40",
      "fontSize": "14px",
      "fontName": "",
      "fontstyle":"",
      "fontweight":"",
      "textdecoration":"",
      "fontColor": "",
      "fontfamily":"Roboto",
      "offsetX": event.offsetX,
      "offsetY": event.offsetY,
      "height": 0,
      "width": 0,
      "Imageheight": "100px",
      "Imagewidth": "100px",
      "textalign":textaligns,//"left",       
      "chkSelectedValues": [],
      "rbSelectedValues": "",
      "fieldNames": "",
      "buttonText":"",
      "signatureBase64":"",
      "signatureText":'',
      "drawBase64":"",
      "colorCode":colorCode,
      "colorCodeAlpha":colorCodeAlpha,
      'signInitialFontFamily':'',
      'Lat' :'',
      'Long' :'',
      "selectedParticipant":selectedParticipant,
      "backgroundColor":"",
      "buttonName":"Button",
      "buttonURL":"",
      "brushColor":"",
      "rotation":0,
      "ShowtoolDetail":false,
      "offsetWidth":this.offsetWidth,
      "offsetHeight":this.offsetHeight,
      "showRequiredControls":false,
      "filledData":false,
    }

    if (this.particiantJsonList.find(x => x.img == list.img)) {
      this.particiantJsonList.find(x => x.img == list.img).fields.push(fieldJson);
      this.particiantJsonList = this.particiantJsonList;
     }
    }

    if(this.clickinSignature==true) {

       var name = "Signature" + '-' + new Date().getTime();
 
       var textaligns:string="center";
      //  this.offsetWidth=140;
      //  this.offsetHeight=70;
         this.offsetWidth=79;
         this.offsetHeight=52;

       if(this.particiantJsonList.length > 0) {
        var color = this.particiantJsonList[0].fields;
         if(color.length > 0){
          colorCode = color[0].colorCode;
          colorCodeAlpha = color[0].colorCodeAlpha;
         // selectedParticipant = color[0].selectedParticipant;
       }  
      }     

      let fieldJson = {
       "id": name,
       "fieldID": 0,
       "fieldName": "Signature",
       "Control":"Static",
       "folderID": 0,
       "folderName": "",
       "fieldTypeID": 0,
       "fieldTypeName": "Signature",
       "placeholder": "",
       "defaultValue": "",
       "fillList": [],
       "FileData":[],
       "ImageData":[],
       "rows":"",
       "column":"",
       "selectedValue": '',
       "isRequired": false,
       "readonly": false,
       "charLimit": "40",
       "fontSize": "14px",
       "fontName": "",
       "fontstyle":"",
       "fontweight":"",
       "textdecoration":"",
       "fontColor": "",
       "fontfamily":"Roboto",
       "offsetX": event.offsetX,
       "offsetY": event.offsetY,
       "height": 0,
       "width": 0,
       "Imageheight": "100px",
       "Imagewidth": "100px",
       "textalign":textaligns,//"left",       
       "chkSelectedValues": [],
       "rbSelectedValues": "",
       "fieldNames": "",
       "buttonText":"",
       "signatureBase64":"",
       "signatureText":'',
       "drawBase64":"",
       "colorCode":colorCode,
       "colorCodeAlpha":colorCodeAlpha,
       'signInitialFontFamily':'',
       'Lat' :'',
       'Long' :'',
       "selectedParticipant":selectedParticipant,
       "backgroundColor":"",
       "buttonName":"Button",
       "buttonURL":"",
       "brushColor":"",
       "rotation":0,
       "ShowtoolDetail":false,
       "offsetWidth":this.offsetWidth,
       "offsetHeight":this.offsetHeight,
       "showRequiredControls":false,
       "filledData":false,
     }
 
     if (this.particiantJsonList.find(x => x.img == list.img)) {
       this.particiantJsonList.find(x => x.img == list.img).fields.push(fieldJson);
       this.particiantJsonList = this.particiantJsonList;
     }
     }

    this.clickinText=false;
    this.clickinInitials=false;
    this.clickinSignature=false;   
    this.waitPointer=false; 
  }

  width: number;
  height: number;
  cavasSize:number
  ImgWidth:number

  onResized(event: ResizedEvent) {
    this.ImgWidth = event.newWidth;
    this.width = event.newWidth/750;
    this.height = event.newHeight;

    if(this.cavasSize < 1306){
      this.width = 0.9
    }
    if(this.cavasSize < 1242){
      this.width = 0.8
    }    
  }

  onResizeStop(event,data,id) {
    if (this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     var cntrol = this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id);    
     this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).offsetWidth =event.size.width; 
     this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).offsetHeight =event.size.height; 
     this.particiantJsonList = this.particiantJsonList; 
     }
   }
 
   
  onMoveEnd(event,data,parentCtrl,childCtrl) {
    this.endOffset.x = event.x;
    this.endOffset.y = event.y;
    this.xposition = this.endOffset.x;
    this.yposition = this.endOffset.y;    
    if(this.particiantJsonList.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
     let fieldType=this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).fieldTypeName;
     this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetX =  Number(this.xposition) == undefined ? '' :  Number(this.xposition);
     this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == parentCtrl.id).offsetY =  Number(this.yposition) == undefined ? '' :  Number(this.yposition);
     this.particiantJsonList = this.particiantJsonList;
   }
  }
  

  // ==== For Search City/State/Zip === //

states: string[] = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
  'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
  'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
  'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
  'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

cityOption: string[]=[];
zipOption: any[];
stateList: any[];
cityValue: any;
stateValue: any;
zipValue: any;

searchCity(name :any){ 
  var ReqModel={
    databaseID:Number(this.databaseId),
    Name: name,
    userID:this.userID
  } 
  this.formsService.searchTransCities(ReqModel).subscribe(response => {
    if (response != undefined) {
      if (response.status == this.statusConstant.statusSuccess) {          
        this.cityOption=[];
        response.data.forEach(element => {
          this.cityOption.push(element.name);
        });
      }
      else {
      }
    }
  });
}

getStateDropdownList(countryId:any) {
  if (countryId!=undefined) {
    this.formsService.getStateList(countryId).subscribe(response => {
        if (response!=undefined) {
          if (response.status == this.statusConstant.statusSuccess) {
            this.stateList = [];
            if(countryId == 231 || countryId == 38){               
                response.data  =  response.data.filter((x) => x.abbreviation != null);
                response.data.forEach(e => {
                  this.stateList.push(e.abbreviation);
                });
              }else{
                response.data.forEach(e => {
                  this.stateList.push(e.stateName);
                });
              } 
          }
        }
      });
  }
}


searchZip(zip :any){
  var ReqModel={
    databaseID:Number(this.databaseId),
    ZipCodeValue:zip,
    userID:this.userID
  } 
  this.formsService.searchTransZip(ReqModel).subscribe(response => {
    if (response != undefined) {
      if (response.status == this.statusConstant.statusSuccess) {     
        this.zipOption=[];
        response.data.forEach(element => {
          this.zipOption.push(element.zipCodeValue);
        });
      }
      else {
      }
    }
  });
}


cityselected(event: MatAutocompleteSelectedEvent, data: any, id) {
  let selectedCtrlFolderID= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).folderID;
    
 let contactFolder:any= []//folderAccess.find(b=>b.folderName=='Contact');
 contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
  if (selectedCtrlFolderID==contactFolder[0].folderID &&this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue =event.option.value;;
    
    let field =  this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == id);
   
    this.particiantJsonList.forEach(element => {
    element.fields.forEach(fe => {
     if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
     {
       fe.selectedValue=event.option.value;;
     }
    });
  });
  }
  let coretFolder:any=[]; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
  coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));
  if (selectedCtrlFolderID==coretFolder[0].folderID &&this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0) {
    this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = event.option.value;;
    
    let field =  this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == id);
   
    this.particiantJsonList.forEach(element => {
    element.fields.forEach(fe => {
     if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
     {
       fe.selectedValue=event.option.value;;
     }
    });
  });
  }

  let comFolder:any=[];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
  comFolder.push(this.fieldFolders.find(n=>n.name=='Company'));
  if (selectedCtrlFolderID==comFolder[0].folderID &&this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0) {
    this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = event.option.value;;
    
    let field =  this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == id);
   
    this.particiantJsonList.forEach(element => {
    element.fields.forEach(fe => {
     if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
     {
       fe.selectedValue= event.option.value;;
     }
    });
  });
  }

  if ((selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
  || (selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
   || (selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0))
 {
  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;

 }
 else if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID==0)
   {
       this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = event.option.value;
       this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
   }
   else if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID>0)
   {
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = event.option.value;
   }
}

zipselected(event: MatAutocompleteSelectedEvent, data: any, id) {
  let selectedCtrlFolderID= this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).folderID;
    
 let contactFolder:any= []//folderAccess.find(b=>b.folderName=='Contact');
 contactFolder.push(this.fieldFolders.find(n=>n.name=='Contact'));
  if (selectedCtrlFolderID==contactFolder[0].folderID &&this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonList.find(x => x.img == data.img).fields.length > 0) {
    this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue =event.option.value;;
    
    let field =  this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.find(m => m.id == id);
   
    this.particiantJsonList.forEach(element => {
    element.fields.forEach(fe => {
     if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
     {
       fe.selectedValue=event.option.value;;
     }
    });
  });
  }
  let coretFolder:any=[]; //{folderID:17};//folderAccess.find(b=>b.folderName=='Contact');
  coretFolder.push(this.fieldFolders.find(n=>n.name=='Core'));
  if (selectedCtrlFolderID==coretFolder[0].folderID &&this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0) {
    this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = event.option.value;;
    
    let field =  this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.find(m => m.id == id);
   
    this.particiantJsonList.forEach(element => {
    element.fields.forEach(fe => {
     if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
     {
       fe.selectedValue=event.option.value;;
     }
    });
  });
  }

  let comFolder:any=[];// {folderID:19};//folderAccess.find(b=>b.folderName=='Contact');
  comFolder.push(this.fieldFolders.find(n=>n.name=='Company'));
  if (selectedCtrlFolderID==comFolder[0].folderID &&this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0) {
    this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = event.option.value;;
    
    let field =  this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.find(m => m.id == id);
   
    this.particiantJsonList.forEach(element => {
    element.fields.forEach(fe => {
     if(fe.fieldName==field.fieldName && fe.folderID==field.folderID && this.groupRelationParticipantId==fe.selectedParticipant?.groupRelationParticipantMappingID)
     {
       fe.selectedValue= event.option.value;;
     }
    });
  });
  }

  if ((selectedCtrlFolderID==contactFolder[0].folderID && this.particiantJsonListAutoFill.find(x => x.img == data.img) && this.particiantJsonListAutoFill.find(x => x.img == data.img).fields.length > 0)
  || (selectedCtrlFolderID==coretFolder[0].folderID && this.particiantJsonListAutoFillCore.find(x => x.img == data.img) && this.particiantJsonListAutoFillCore.find(x => x.img == data.img).fields.length > 0)
   || (selectedCtrlFolderID==comFolder[0].folderID && this.particiantJsonListAutoFillCom.find(x => x.img == data.img) && this.particiantJsonListAutoFillCom.find(x => x.img == data.img).fields.length > 0))
 {
  this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;

 }
 else if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID==0)
   {
       this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = event.option.value;
       this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant.groupRelationParticipantMappingID=this.groupRelationParticipantId;
   }
   else if(this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedParticipant?.groupRelationParticipantMappingID>0)
   {
    this.particiantJsonList.find(x => x.img == data.img).fields.find(m => m.id == id).selectedValue = event.option.value;
   }
}


}
